<template>
  <div v-show="workflowModel.active <= 3">
    <div class="d-flex page-shell" :class="{ 'config-split': workflowModel.active <= 3 }">
      <configurator-menu
        class="col flex-container sidemenu"
        :mesh-editor-loading-props="meshEditorLoading"
        :supplierUrl="supplierUrl"
        :order="orderData"
        :order-template="orderTemplate"
        :workflow-model="workflowModel"
        :mesh-tree-data="selectedProductInput"
        :product-type-id="productTypeId"
        :product-id="productId"
        :embossing-id="embossingId"
        :wtransfer-id="wtransferId"
        :selected-engraving="selectedEmbossing"
        :selected-texture="selectedWtransfer"
        :selected-color="selectedColor"
        :selected-embossing-color="selectedEmbossingColor"
        :selected-texture-color="selectedTextureColor"
        :mesh-engravings="getMeshEngravings2()"
        :mesh-colors="getAllColors()"
        :mesh-embossing-colors="getMeshEngravingColors()"
        :mesh-texture-colors="getMeshTextureColors()"
        @zip-changed="(zip: string) => zipChanged(zip)"
        @product-selected="handleProductSelected"
        @part-selected="(part: MeshTreeDataItem | null) => selectedProductInput.selectItem(part, true, true)"
        @handle-select-embossing="(fileTextureId: number | UtilityFile | null) => handleSelectEmbossing(fileTextureId)"
        @mesh-color-selected="colorizeSelectedMesh"
        @mesh-embossing-color-selected="colorizeSelectedEmbossing"
        @mesh-texture-color-selected="colorizeSelectWtransfer"
        @abortCurrentLoading="abortCurrentRequest"
      />

      <!-- Right Content -->
      <div class="flex-grow-1 main-content" style="overflow: hidden; margin-left: 0; position: relative;">
        <!-- <button v-if="this.selectedProductInput.treeData.length > 0" id="btn-ar" class="workflow-button" @click="startAr">{{enterAR ? 'Close' : 'Start'}} AR</button> -->
        <mesh-editor
          ref="meshEditor"
          :style="workflowModel.active <= 3 ? '' : 'height: 93vh !important'"
          v-model="selectedProductInput"
          :productTypeId="productTypeId"
          :has-toolbar="isEditor()"
          :can-toggle-pivot-mode="true"
          :can-select="[1, 2, 3].includes(this.workflowModel.active)"
          :can-toggle-bones="true"
          :can-deform="true"
          :can-curve="true"
          :activate-aline-to-floor="true"
          :activate-bones="true"
          :active-editor-mode="true"
          :activate-display-bounding-box="true"
          :reset-on-pivot-changed="true"
          :fit-camera-to-scene="true"
          :can-undo="true"
          :can-part-select="isEditor()"
          :can-toggle-opacity="true"
          :has-navigation-bar="true"
          :can-xr="true"
          :show-siderbar-right-tools="isSidebarRight"
          :show-orientation-gizmo="true"
          :fullscreen="false"
          :is-loading-download-object="isLoadingDownloadObject"
          :is-show-deformation-editor="isShowDeformationEditor"
          :is-deformation-active="isDeformationActive"
          :is-user-supplier="isUserSupplier"
          :is-applying-colors="isApplyingColors"
          :is-workflow-footer="false"
          @meshes-loaded="meshesLoaded()"
          @download3DFileToObj="(sceneRef: THREE.Scene | undefined) => download3DFileToObj(sceneRef)"
          @showProductParameterModalDialog="showProductParameterModalDialog(selectedModel, true)"
          @closeDeformationEditor="isShowDeformationEditor = !isShowDeformationEditor"
          @showComponentsModalDialog="showComponentsModalDialog(null)"
        />

        <!-- Product parameter modal dialog -->
        <product-parameter-modal-dialog
          ref="productParameterModal"
          v-if="productTypeId === 1"
          :product="selectedProductInput"
          :selected-model="selectedModel"
          :video-metadata="videoMetadata"
          :authentication="authentication"
          :order-data="orderData"
          :product-parameter-embossing="productParameterEmbossing"
          @isLoadingDeformation="isLoadingDeformation = $event"
          @deformationResult="updateMeshInViewer"
          @zip-changed="(zip: string) => zipChanged(zip)"
          @update-product-list-state="onUpdateProductListState"
          @handle-show-mesh-editor="selectedModel ? handleShowMeshEditor(selectedModel) : null"
          @convert-to-url="selectedModel ? convertToUrl(selectedModel) : null"
        />

        <!-- Deformation Mesh Editor -->
        <MeshDeformationEditor
          v-show="[1, 2, 3].includes(workflowModel.active)"
          :is-show-deformation-editor="isShowDeformationEditor"
          :is-loading-deformation="isLoadingDeformation"
          :is-loading-download-object="isLoadingDownloadObject"
          :is-deformation-active="isDeformationActive"
          :product-title="productTitle"
          :order-data="orderData"
          :selected-product-input="selectedProductInput2"
          :workflow-model="workflowModel"
          :selected-model="selectedModel"
          @meshes-loaded="meshesLoaded()"
          @download3-d-file-to-obj="(sceneRef: THREE.Scene | undefined) => download3DFileToObj(sceneRef)"
          @show-product-parameter-modal-dialog="showProductParameterModalDialog(selectedModel, true)"
          @close-deformation-editor="isShowDeformationEditor = !isShowDeformationEditor"
        />
      </div>
    </div>
  </div>

  <div v-if="workflowModel.activeProgressName() === CustomizeProgress.form" v-loading="sendingOrder">
    <order-form
      :order="orderData"
      style="height: 93vh; width: calc(100vw - 5rem); overflow-x: hidden !important"
      :selected-model="selectedModel"
      :selected-colors="meshColorList"
      :selected-engravings="meshEmbossingList"
      :selected-engraving-colors="meshEmbossingColorList"
      :selected-textures="meshWtransferList"
      :selected-texture-colors="meshWtransferColorList"
      :mesh-tree-data="selectedProductInput"
      :screen-shots="screenshotSrc"
      :mesh-engravings="getMeshEngravings2()"
      :mesh-colors="getAllColors()"
      :mesh-embossing-colors="getMeshEngravingColors()"
      :mesh-texture-colors="getMeshTextureColors()"
      :sending-order="sendingOrder"
      :loading-offer-pdf="loadingOfferPdf"
      :is-loading-button-part-list="isLoadingButtonPartList"
      :price="workflowModel.totalPrice"
      @handle-select-embossing="(fileTextureId: number | UtilityFile | null) => handleSelectEmbossing(fileTextureId)"
      @mesh-color-selected="colorizeSelectedMesh"
      @mesh-embossing-color-selected="colorizeSelectedEmbossing"
      @mesh-texture-color-selected="colorizeSelectWtransfer"
      @on-submit="onOrderSubmit"
      @previousStep="goToStepThree"
      @confirm-offer-pdf="confirmOfferPdf()"
      @confirm-offer-pdf-v2="downloadOfferPDF()"
      @confirm-part-list-pdf-v2="downloadPartListPDF()"
    />
  </div>

  <div v-if="workflowModel.activeProgressName() === CustomizeProgress.overview" id="completed-order" style="height: 93vh !important; width: auto">
    <div class="container text-center align-items-center">
      <p class="title mb-5">
        {{ $t('components.order-summary.thankyou') }}
      </p>

      <div class="section-group end">
        <button v-loading="loadingOfferPdf" class="btn btn-secondary" :disabled="loadingOfferPdf || isLoadingButtonPartList" @click="downloadOfferPDF()">
          {{ $t('components.order-summary.downloadOfferPdfButton') }}
        </button>

        <button v-loading="loadingOfferPdf" class="btn btn-secondary" :disabled="loadingOfferPdf || isLoadingButtonPartList" @click="goHome()">
          {{ $t('components.order-summary.newOrder') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, ComponentBase, Prop, Watch } from 'vue-facing-decorator';
import * as THREE from 'three';
import { Color } from 'three';
import { ElMessage, ElMessageBox } from 'element-plus';
import type { UploadFile, UploadStatus } from 'element-plus/es/components/upload/src/upload';
import { cloneDeep } from '@apollo/client/utilities';

import * as rndService from '@/services/api/rndService';
import MeshEditor from '@/components/three/scenes/MeshEditor.vue';
import { MeshTreeData, MeshTreeDataGroupItem, MeshTreeDataItem } from '@/types/ui/MeshTreeData';
import * as ProductDbService from '@/services/api/productDbService';
import { EmbossingColors, ProductColors } from '@/services/api/productDbService';
import { FileType3D, FileTypeImage, FileTypeVideo, getFileType, UploadCategory } from '@/types/enum/upload';
import * as THREEMaterial from '@/utils/three/material';
import { cleanUpScene } from '@/utils/three/importExport';
import {
  BalconyType,
  BodySide,
  MountingType,
  PaneelType,
  ZipType,
  MountingProfileType,
  LightColorType,
  LightIntensityType,
  ProfileColor,
  IPRatingType,
  LightCoverType,
  BathtubType,
  PanelVariant,
} from '@/types/enum/order';
import * as LayoutUtility from '@/utils/layout';
import { deleteFileFromAzure, deleteFileMetadataToAzureByProudctId, exportOBJFromScene, fileContentToBase64, TableField } from '@/utils/file';
import * as OrderService from '@/services/api/orderService';
import { OrderTemplate } from '@/services/api/orderService';
import { WorkflowModel } from '@/types/ui/WorkflowModel';
import { CustomizeProgress } from '@/types/enum/workflow';
import * as THREEEnum from '@/types/enum/three';
import { DefaultUndoRedo } from '@/types/ui/HistoryList';
import * as modelService from '@/services/api/modelService';
import * as customerService from '@/services/api/customerService';
import { Model2 } from '@/types/api/Model/Model';
import * as TemplateService from '@/services/api/templateService';
import { ProductQuality } from '@/types/enum/template';
import { Color as AttributeColor } from '@/types/api/Model/Attributes/Color';
import { RGB } from '@/types/api/Utility/RGB';
import { Palette } from '@/types/api/Utility/Palette';
import { File as UtilityFile } from '@/types/api/Utility/File';
import { Component as Component1 } from '@/types/api/Model/Component';
import { Engraving } from '@/types/api/Model/Attributes/Engraving';
import { Reseller } from '@/types/api/User/Reseller';
import Auth from '@/services/api/auth';
import { Print } from '@/types/api/Model/Attributes/Print';
import { waitFor } from '@/utils/three/webGlContext';
import { Side } from '@/types/api/Patient/Side';
import { Size as UtilitySize } from '@/types/api/Utility/Size';
import * as FormBuilderService from '@/services/api/formBuilderService';
import * as THREECamera from '@/utils/three/camera';
import { unit_type } from '@/types/api/Model/UnitType';
import { SupportedValues, SupportedValuesTextures } from '@/types/api/Utility/SupportedValues';
import { useProductStore } from '@/stores/productStore';
import Header from '@/components/layout/Header.vue';
import ConfiguratorMenu from '@/components/configurator/ConfiguratorMenu.vue';
import OrderForm from '@/components/configurator/OrderForm.vue';
import { calculateMeshRadiusPoint } from '@/utils/calculate';
import { createPdfOfferTemplate, createPdfPartListTemplate, generatePDF } from '@/utils/pdfTemplates';
import { getI18nLocale } from '@/i18n';
import de from '@/locales/de.json';
import en from '@/locales/en.json';
import { sendEmailOrderConfirmationTemplate, sendEmailOrderTemplate } from '@/services/api/email';

import Cookies from 'js-cookie';
import { Key } from '@/types/constants/Key';
import { Role } from '@/types/enum/user';
import { IPInfo } from '@/services/api/ip';

import { defaultPriceCountryCode } from '@/types/constants/price';
import { useUserStore } from '@/stores/userStore';
import { Domain } from '@/types/api/Business/Domain';
import { removeWordFromString } from '@/utils/formBuilder';
import { useRoute, useRouter } from 'vue-router';
import { FenceSunService } from '@/types/constants/fence-sun';
import OrderFormUploadData from '@/components/forms/OrderFormUploadData.vue';
import ProductParameterModalDialog from '@/components/productParameters/ProductParameterModalDialog.vue';
import MeshDeformationEditor from '@/components/three/scenes/MeshDeformationEditor.vue';
import { useComponentStatusStore } from '@/stores/componentStatus';
import { getComponentSettings, useComponentSettingStore } from '@/utils/componentSettings';
import { ref } from 'vue';
import { useFeatureFlagStore } from '@/stores/featureFlagStore';
import { createOrder } from '@/services/api/newOrderService';


//#region interfaces
interface UploadData {
  name: string;
  url: string;
  uid: number;
  status?: UploadStatus;
  base64?: string;
}

interface ImageData {
  uuid: string;
  name: string;
  url: string;
  thumbnailUrl: string;
}

interface Embossing {
  name: string;
  colors: string[];
}

interface MeshConfig {
  filename: string;
  colors: { [name: string]: string[] } | undefined;
  embossing: Embossing[] | undefined;
  wtransfer: string[] | undefined;
  thumbnail: string;
}

interface ProductConfig {
  type: string;
  name: string;
  thumbnail: string;
  meshes: MeshConfig[];
}

export interface OrderData {
  technicianFirstname: string;
  technicianLastname: string;
  technician: string;
  company: string;
  customerNr: string;
  orderNr: string;
  billingNr: string;
  commissionNo: string;
  vrNumber: string;
  vgNumber: string;
  vsgNumber: string;
  mail: string;
  coverModel: string;
  prothesisType: string;
  bodySide: string;
  kneeJoint: string;
  foot: string;
  zip: string;
  sewInByCustomer: boolean;
  cosmeticEndingAtFoot: boolean;
  design: string;
  individualDesign: boolean;
  designFiles: UploadData[];
  heightWithoutDeduction: number;
  heightDeduction: number;
  heightWithDeduction: number;
  depth: number;
  depthRight: number;
  bilateralAmputee: boolean;
  calfCircumferenceWithoutDeduction: number;
  calfCircumferenceDeduction: number;
  calfCircumferenceWithDeduction: number;
  ankleCircumference: number;
  imageFiles: UploadData[];
  scanFiles: UploadData[];
  remarks: string;
  isPrivacy: boolean;
  privacy: string;
  balconyType: string;
  mountingType: string;
  paneelType: string;
  orientationType: string;
  fenceType: string;
  color: string;
  mountingProfileType: string;
  lightCoverType: string;
  iPRatingType: string;
  lightColorType: string;
  lightIntensityType: string;
  vFour: boolean;
  eloxed: boolean;
  lightLength: number;
  bathtubType: string;
  wallpanels: boolean;
  antiSlip: boolean;
  panelVariant: string;
  singleType: string[];
  comboType: string;
  panelWidth: number;
  angle: number;
  angleRight: number;
  angleLeft: number;
  varnish: string;
  totalPrice?: number;
  colorList?: string[];
  embossingList?: string[];
  fenceSunServices?: FenceSunService[];
}

//#endregion interfaces

@Component({
  methods: { ref },
  components: {
    OrderFormUploadData,
    Header,
    ConfiguratorMenu,
    MeshEditor,
    OrderForm,
    ProductParameterModalDialog,
    MeshDeformationEditor
  }
})

@ComponentBase
export default class ConfiguratorPage extends Vue implements DefaultUndoRedo {
  @Prop({ default: null }) productTypeId!: number | null;
  @Prop({ default: null }) supplierUrl!: string | null;

  @Prop({ default: null }) productId!: number | null;
  @Prop({ default: null }) embossingId!: number | number[] | null;
  @Prop({ default: null }) wtransferId!: number | number[] | null;
  @Prop({ default: null }) colorId!: number | number[] | null;
  @Prop({ default: null }) embossingColorId!: number | number[] | null;

  enterAR = false

  locale = getI18nLocale() === Key.language.default ? en : de;
  authentication = Auth.getInstance();
  productStore = useProductStore();
  userStore = useUserStore();
  router = useRouter();
  route = useRoute();
  settingStore = useComponentSettingStore();
  //#region properties
  productTypes = this.productStore.productTypes;
  productConfigurationDB: ProductConfig[] = [];
  productDB: ProductDbService.ProductData[] = [];
  selectedProductId = '';
  selectedEmbossingContent = '';
  selectedModelId: number | null = null;
  selectedProductInput: MeshTreeData = new MeshTreeData(null, this);
  selectedProductInput2: MeshTreeData = new MeshTreeData(null, this);
  templateMesh: MeshTreeDataItem | null = null;
  meshCountItemList: MeshTreeDataGroupItem[] = [];
  selectedModel: Model2 | null = null;
  colors: { [name: string]: string[] } = ProductColors;
  embossingDB: ImageData[] = [];
  wtransferDB: ImageData[] = [];
  fullscreenLoading = false;
  productsLoading = false;
  meshEditorLoading = false;
  currentPage = 1;
  width = window.innerWidth;
  lastUpdateDB = -1;
  transparentColor = '#d3d3d3';
  transparentColorRgb = {
    name: 'none',
    red: 211,
    green: 211,
    blue: 211,
  } as RGB;
  blankFileName = 'blank';
  automaticSize = false;
  selectedProductQuality = ProductQuality.low.toString();
  sendingOrder = false;

  zipperColors: RGB[] = [
    { name: 'white', red: 255, green: 255, blue: 255 } as RGB,
    { name: 'beige', red: 242, green: 231, blue: 191 } as RGB,
    { name: 'black', red: 40, green: 42, blue: 42 } as RGB,
    { name: 'gray', red: 136, green: 140, blue: 136 } as RGB,
  ];

  bestMatchingZipperColor: RGB = this.zipperColors[1];

  colorListLoading = new Map<string, boolean>();
  embossingListLoading = new Map<string, boolean>();
  wtransferListLoading = new Map<string, boolean>();
  sizeListLoading = new Map<string, boolean>();

  meshGroupedPartItems: { [key: string]: MeshTreeDataGroupItem[] } = {};

  colorList = [...new Set(this.meshColorList.map((c) => this.$t(`views.colors.${c.name}`)))];
  embossingList = [
    ...new Set(this.meshEmbossingList.map((e) => this.$t(`views.designs.${e.name}`)) ?? []),
    ...new Set(this.meshWtransferList.map((w) => this.$t(`views.designs.${w.name}`)) ?? []),
  ];

  abortController = new AbortController();
  deformationAbortController = new AbortController();

  modelList: Model2[] = [];
  selectedScan: UtilityFile | null = null;
  selectedSkeleton: UtilityFile | null = null;

  loadingOfferPdf = false;

  loadedScan: Component1 | null = null;

  workflowModel: WorkflowModel<CustomizeProgress> = new WorkflowModel('customize-progress', CustomizeProgress);
  CustomizeProgress = CustomizeProgress;
  reseller: Reseller | null = null;
  isUserSupplier = this.userStore.roles.includes(Role.Supplier);
  filteredBalconyModels: Model2[] | null = null;
  filteredFenceSunModels: Model2[] | null = null;
  filteredFenceModels: Model2[] | null = null;
  filteredLighModels: Model2[] | null = null;
  filteredBathtubModels: Model2[] | null = null;

  BodySide = BodySide;
  FileType = FileType3D;
  ZipType = ZipType;
  ProductQuality = ProductQuality;
  getFileType = getFileType;
  productList: Model2[] = [];
  suppliersWithHiddenBackArrow = ['wjtortho'];
  hideBackArrow = false;

  THREEEnum = THREEEnum;

  embossingColors: string[] = EmbossingColors;
  orderData: OrderData = {
    technicianFirstname: '',
    technicianLastname: '',
    technician: '',
    company: '',//this.getCompanyDomain(),
    customerNr: '',
    orderNr: '',
    billingNr: '',
    commissionNo: '',
    vrNumber: '',
    vgNumber: '',
    vsgNumber: '',
    mail: '',
    coverModel: '',
    prothesisType: '',
    bodySide: JSON.parse(localStorage.getItem('bodySide') ?? '"Right"'),
    kneeJoint: JSON.parse(localStorage.getItem('kneeJoint') ?? '""'),
    foot: '',
    zip: 'yes',
    sewInByCustomer: false,
    cosmeticEndingAtFoot: false,
    balconyType: BalconyType.uForm,
    mountingType: JSON.parse(localStorage.getItem('mountingType') ?? '"front"'),
    individualDesign: false,
    design: '',
    designFiles: [],
    heightWithoutDeduction: 351,
    heightDeduction: -1,
    heightWithDeduction: 49,
    depth: JSON.parse(localStorage.getItem('depth') ?? "350"),
    depthRight: JSON.parse(localStorage.getItem('depthRight') ?? "1000"),
    bilateralAmputee: false,
    calfCircumferenceWithoutDeduction: JSON.parse(localStorage.getItem('calfCircumferenceWithoutDeduction') ?? "240"),
    calfCircumferenceDeduction: -2,
    calfCircumferenceWithDeduction: 48,
    ankleCircumference: 50,
    imageFiles: [],
    scanFiles: [],
    remarks: '',
    isPrivacy: false,
    privacy: '',
    paneelType: JSON.parse(localStorage.getItem('paneelType') ?? '"landscape"'),
    orientationType: JSON.parse(localStorage.getItem('orientationType') ?? '"south"'),
    fenceType: JSON.parse(localStorage.getItem('fenceType') ?? '"straight"'),
    color: ProfileColor.black,
    mountingProfileType: MountingProfileType.lltwentyfive,
    lightCoverType: LightCoverType.versionOne,
    iPRatingType: IPRatingType.iPtwenty,
    lightColorType: LightColorType.threethousandK,
    lightIntensityType: LightIntensityType.six,
    vFour: false,
    eloxed: false,
    lightLength: 5,
    bathtubType: BathtubType.relax,
    wallpanels: false,
    antiSlip: false,
    panelVariant: PanelVariant.single,
    singleType: [],
    comboType: 'right',
    angle: 0,
    panelWidth: 210,
    angleRight: 90,
    angleLeft: 90,
    varnish: 'none',
    totalPrice: 0,
    colorList: [],
    embossingList: [],
    fenceSunServices: [],
  };
  orderTemplate: OrderTemplate = {
    HTMLTemplate: '',
    HTMLConfirmationTemplate: '',
  };

  IPInfo: IPInfo | null = null;
  screenshotSrc: string[] = [];

  private productDetailsModalDialog: any = null;
  private productParameterModalDialog: any = null;
  private componentsModalDialog: any = null;
  private isLoadingButtonPartList = false;
  private videoMetadata: TableField = {
    productId: '',
    filename: '',
    fileType: FileTypeVideo.WEBM,
    fileUrl: '',
  };
  productParameterEmbossing = false;
  isLoadingDownloadObject = false;
  isLoadingDeformation = false;
  isDeformationActive = false;
  isShowDeformationEditor = false;
  isSidebarRight = false;
  isApplyingColors = false;

  componentStatusStore = useComponentStatusStore();
  featureFlagStore = useFeatureFlagStore();


  private configStoreTimeout: number | undefined;

  private attrLoadPromise: Promise<void> | null = null;
  mounted(): void {
    if(!this.featureFlagStore.isConfiguratorOrderEnabled()){
      this.router.back();
      return
    }
    const urlProductId = Number(this.route.query.productId);
    const urlProductTypeId = Number(this.route.query.productTypeId);

    if (this.$refs.productParameterModal) {
      this.productParameterModalDialog = (this.$refs.productParameterModal as ProductParameterModalDialog).initModal();
    }
  }

  get isUploading(): boolean {
    return this.componentStatusStore.objLoaded;
  }

  async processComponentTree(): Promise<void> {
    const treeData = [...this.selectedProductInput.treeData].reverse();

    for (const component of treeData) {
      const id = component.componentId;

      if (id != null) {
        const config = getComponentSettings(id);
        
        if (!config) {
          await this.colorizeComponentID(id, component.colors!.value.name, component.embossing!, component.embossingColor!)          
        }
        if (config) {
          await this.colorizeComponentID(id, config.color, config.embossing, config.embossingColor);          
        }
      }
    }
  }

  @Watch('workflowModel.active')
  onStepChange(newVal: number, oldVal: number) {
    const type    = (this.selectedModel?.product.type.name || '').toLowerCase();
    const variant = (this.selectedModel?.product.name      || '').toLowerCase();
    const meshEditor: any = this.$refs.meshEditor;

    switch (newVal) {
      case 1:
        if (oldVal === 5) {
          this.selectedProductInput.clear();
          this.workflowModel.totalPriceArray.clear();
          this.abortController.abort();
          this.colorListLoading.clear();
          this.embossingListLoading.clear();
          this.wtransferListLoading.clear();
          this.selectedScan = null;
          this.screenshotSrc = [];
          this.loadedScan = null;
        }
        break;
      case 2:
        this.orderData.kneeJoint = ''
        if (
          this.productTypeId === 1 &&
          type.includes('covers') &&
          variant.includes('s-cover')
        ) {
          this.workflowModel.setStep(3);
          return;
        }
        if (this.productTypeId === 215 &&
          type.includes('brace')) {
            this.orderData.bodySide = BodySide.none
            this.orderData.depth = 0
            this.orderData.calfCircumferenceWithoutDeduction = 0
          return;
        }
        break;
      case 4:
        if (meshEditor) {
          this.screenshotSrc = [];
          this.takeScreenshotOfCustomView(meshEditor, THREEEnum.Views.custom);
        }
    }
    if ([1, 2, 3].includes(newVal)) {
      this.triggerRendererResize();
    }
  }
  private triggerRendererResize() {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'));
      const m = this.$refs.meshEditor as any;
      if (m?.resize) m.resize();
    });
  }
  onOrderSubmit() {
    if(!this.sendingOrder) {
      this.sendRequest();
    }
  }

  goToStepThree() {
    this.workflowModel.setStep(3);
  }

  async download3DFileToObj(sceneRef?: THREE.Scene): Promise<void> {
    this.isLoadingDownloadObject = true;

    const threeData = this.getActivePart();
    let scene: THREE.Scene | undefined = undefined;

    if (!sceneRef) {
      scene = threeData?.scene;
    } else {
      scene = (sceneRef as any)?.scene as THREE.Scene;
    }

    const filename = threeData?.name ?? '';

    if (!scene) {
      throw new Error('3D object file cannot be downloaded');
    }

    setTimeout(async () => {
      await exportOBJFromScene(scene, filename, true);
      this.isLoadingDownloadObject = false;
    }, 5000);
  }

  isEditor(): boolean {
    return false;
  }


  checkParameters() {
    if (this.productId && this.productId < this.modelList.length) {
      //this.handleSelectProduct(this.modelList[this.productId]);
      this.workflowModel.OnClickNextAction(1);
    }

    if (this.embossingId) {
      this.workflowModel.setStep(2);
    } else if (this.wtransferId) {
      this.workflowModel.setStep(1);
    }
  }

  getProducts(models: Model2[]) {
    const productList: Model2[] = [];
    for (const model of models) {
      if (productList.findIndex((pt) => pt.product.productId == model.product.productId) === -1) {
        const newModel = cloneDeep(model);
        const sampleImagePaths = model.product.sampleImagePaths?.map((s) => s.content);
        const thumbnailContent = model.product.thumbnail.content;
        if (!sampleImagePaths?.includes(thumbnailContent) && sampleImagePaths) {
          newModel.product = {
            ...model.product,
            sampleImagePaths: [...model.product.sampleImagePaths, model.product.thumbnail],
          } as any;
        }
        productList.push(newModel);
      }
    }
    this.productList = productList;
  }

  getCompanyDomain() {
    const domain = this.userStore?.domain;
    try {
      if (domain) {
        const urlSuffix = domain?.urlSuffix;
        return urlSuffix.charAt(0).toUpperCase() + urlSuffix.slice(1);
      } else {
        return '';
      }
    } catch (error) {
      return '';
    }
  }

  @Watch('workflowModel.totalPrice', { immediate: true })
  onPriceChange(): void {
    this.orderData = {
      ...this.orderData,
      totalPrice: this.workflowModel.totalPrice,
    };
    localStorage.setItem('orderForm', JSON.stringify(this.orderData));
  }

  @Watch('meshColorList', { immediate: true })
  onMeshColorListChanged(): void {
    this.orderData = {
      ...this.orderData,
      colorList: this.meshColorList.map((c) => (this as any).$t(`views.colors.${c.name}`)),
    };
    localStorage.setItem('orderForm', JSON.stringify(this.orderData));
  }
  @Watch('meshEmbossingList', { immediate: true })
  onEmbossingListChanged(): void {
    this.orderData = {
      ...this.orderData,
      embossingList: this.meshEmbossingList.map((e) => e.name),
    };
    localStorage.setItem('orderForm', JSON.stringify(this.orderData));
  }

  saveToLocalStorage(key: string, value: any): void {


    if (!this.componentStatusStore.isMounted) {
      return;
    }

    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Failed to save ${key} to localStorage`, e);
    }
  }

  @Watch('orderData.heightWithoutDeduction', { immediate: true, deep: true })
  onHeightChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.heightWithoutDeduction;
      this.saveToLocalStorage('heightWithoutDeduction', value);
    }, 300);
  }

  @Watch('orderData.depthRight', { immediate: true, deep: true })
  onDepthRightChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.depthRight;
      this.saveToLocalStorage('depthRight', value);
    }, 300);
  }
  @Watch('orderData.calfCircumferenceWithoutDeduction', { immediate: true, deep: true })
  onCalfCircumferenceChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.calfCircumferenceWithoutDeduction;
      this.saveToLocalStorage('calfCircumferenceWithoutDeduction', value);
    }, 300);
  }

  @Watch('orderData.bodySide', { immediate: true, deep: true })
  onBodySideChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.bodySide;
      this.saveToLocalStorage('bodySide', value);
    }, 300);
  }

  @Watch('orderData.kneeJoint', { immediate: true, deep: true })
  onKneeJointChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.kneeJoint;
      this.saveToLocalStorage('kneeJoint', value);
    }, 300);
  }
  @Watch('orderData.orientationType', { immediate: true, deep: true })
  onOrientationTypeChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.orientationType;
      this.saveToLocalStorage('orientationType', value);
    }, 300);
  }
  @Watch('orderData.fenceType', { immediate: true, deep: true })
  onFenceTypeChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.fenceType;
      this.saveToLocalStorage('fenceType', value);
    }, 300);
  }
  @Watch('orderData.paneelType', { immediate: true, deep: true })
  onPaneelTypeChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.paneelType;
      this.saveToLocalStorage('paneelType', value);
    }, 300);
  }

  @Watch('orderData.depth', { immediate: true, deep: true })
  onDepthChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.depth;
      this.saveToLocalStorage('depth', value);
    }, 300);
  }
  @Watch('orderData.mountingType', { immediate: true, deep: true })
  onMountingTypeChange(): void {
    if (this.configStoreTimeout) {
      clearTimeout(this.configStoreTimeout);
    }

    this.configStoreTimeout = window.setTimeout(() => {
      const value = this.orderData.mountingType;
      this.saveToLocalStorage('mountingType', value);
    }, 300);
  }

  handleProductSelected(model?: Model2) {
    // Always reset/abort any ongoing request
    this.abortController.abort()
    this.abortController = new AbortController()

    if (!model) return

    this.selectedModel = model

    const typeName = (model.product?.type?.name || '').toLowerCase()
    const variantName = (model.product?.name || '').toLowerCase()
    const isSFlexLower = typeName.includes('s-flex') && variantName.includes('lower')

    // If embossing parameters exist, confirm before continuing
    if (this.productParameterEmbossing) {
      ElMessageBox.confirm(
        this.$t('confirm.deformation.message') as string,
        this.$t('confirm.deformation.title') as string,
        {
          confirmButtonText: this.$t('confirm.deformation.ok') as string,
          cancelButtonText: this.$t('confirm.deformation.cancel') as string,
          type: 'warning',
        }
      ).then(()=>{
        (this.$refs.productParameterModal as ProductParameterModalDialog)?.abortDeformation()
        this.deformationAbortController.abort()
        this.handleSelectProduct(this.selectedModel)

        if (isSFlexLower) {
          this.workflowModel.setStep(3)
        }
      }).catch(()=>{
        this.update3DModel()
      })
      return
    }

    // Default case without embossing confirmation
    this.handleSelectProduct(this.selectedModel)
    if (isSFlexLower) {
      this.workflowModel.setStep(3)
    }
  }

  onUpdateProductListState(payload: { productId: number; name: string }) {
    this.updateProductListState(payload);
  }

  // eslint-disable-next-line consistent-return
  async meshDeformationApi(blob: Blob, filename: string, skeletonRadius: number[], scale_factor: number, outputType = 'base64'): Promise<void | any | null> {
    const apiUrl = import.meta.env.VITE_DEFORMATION_API_URL;
    this.deformationAbortController = new AbortController()
    if (!blob) {
      throw new Error('3D object file cannot be downloaded');
    }

    // Create FormData and add files and other parameters
    const formdata = new FormData();
    formdata.append('file', blob, filename); // Add filename
    formdata.append('radius', JSON.stringify(skeletonRadius));
    formdata.append('sample_rate', '1');
    formdata.append('scale_factor', scale_factor.toString());
    formdata.append('output_type', outputType);

    // Configuration request
    const requestOptions: RequestInit = {
      method: 'POST',
      body: formdata, // Include formdata as the body
      signal: this.deformationAbortController.signal
    };
    try {
      // Fetch to the API
      const response = await fetch(`${apiUrl}/skeleton_based_deformation_v4`, requestOptions);
      if (!response.ok) {
        throw new Error(`API call failed with status ${response.status}`);
      }

      // Return result ...
      const result = outputType === 'base64' ? await response.json() : await response.text();
      return result;
    } catch (error) {
      console.error('API error:', error);
    }
  }

  async updateSelectedModel(data: any): Promise<void> {
    if (!data) return;
    const { output_base64 } = data;

    if (output_base64) {
      if (
        this.selectedModel &&
        this.selectedModel.components &&
        this.selectedModel.components[0] &&
        this.selectedModel.components[0].resolutions &&
        this.selectedModel.components[0].resolutions[0]
      ) {
        const components = this.selectedModel?.components?.map((component, index) =>
          index === 0
            ? {
                ...component,
                resolutions: component.resolutions.map((resolution, index2) =>
                  index2 === 0
                    ? {
                        ...resolution,
                        meshBase64: {
                          ...resolution.meshBase64,
                          content: output_base64,
                        },
                      }
                    : resolution
                ),
              }
            : component
        );
        this.selectedProductInput2.clear();
        this.loadTemplate2({ ...this.selectedModel, components } as any);
      }
    }
  }

  async updateFullModel(data: any): Promise<void> {
    if (!data) return;
    const { output_base64 } = data;

    if (output_base64) {
      if (
        this.selectedModel &&
        this.selectedModel.components &&
        this.selectedModel.components[0] &&
        this.selectedModel.components[0].resolutions &&
        this.selectedModel.components[0].resolutions[0]
      ) {
        const components = this.selectedModel?.components?.map((component, index) => {
          const content = index === 0 ? output_base64 : null;
          return {
            ...component,
            resolutions: component.resolutions.map((resolution, index2) =>
              index2 === 0
                ? {
                    ...resolution,
                    meshBase64: {
                      ...resolution.meshBase64,
                      content,
                    },
                  }
                : resolution
            ),
          };
        });
        this.selectedProductInput2.clear();
        this.loadTemplate2({ ...this.selectedModel, components } as any);
      }
    }
  }

  async getMeshCoversItem(isFull = true): Promise<Blob | undefined> {
    try {
      if (isFull) {
        // Get scene data ...
        const threeData = this.getActivePart();
        const scene = threeData?.scene;
        const filename = threeData?.name ?? '';

        // Convert to blob .obj file ...
        const blob = await exportOBJFromScene(scene, filename, false);

        if (!blob) {
          return undefined;
        }
        return blob;

        // return new Blob([blob], { type: 'text/plain' });
      } else {
        // Get first mesh item ...
        const base64String = this.selectedProductInput.treeData[0]?.base64;
        if (!base64String) return undefined;

        // return with convert to blob file ...
        return new Blob([base64String], { type: 'text/plain' });
      }
    } catch (error) {
      console.error(`Error creating Blob from base64 string: ${error}`);
      return undefined;
    }
  }

  async update3DModel(isFullDeformation = false): Promise<void> {
    if (this.selectedModel?.product.type.name.toLocaleLowerCase() !== 'covers' 
    || this.isTypeBrace(null, this.selectedModel?.product.type.name)
  ) {
      this.hideProductParameterModalDialog();
      this.updateModelSize();
      return;
    }
    this.hideProductParameterModalDialog();
    this.isDeformationActive = true;
    this.isShowDeformationEditor = true;
    this.isLoadingDeformation = true;

    const skeletonRadius: number[] = [1, 1, 1, 1, 1, 1, 1, 1];
    const { depth, calfCircumferenceWithoutDeduction, heightWithoutDeduction } = this.orderData;

    let height = await calculateMeshRadiusPoint(200, 460, 330, heightWithoutDeduction, true);
    let circumTop = await calculateMeshRadiusPoint(0, 430, 265, depth, true);
    let circumBottom = await calculateMeshRadiusPoint(0, 460, 200, calfCircumferenceWithoutDeduction, true);

    if(this.isTypeBrace(null, this.selectedModel?.product.type.name)){
      height = await calculateMeshRadiusPoint(2, 5, 3.5, heightWithoutDeduction, false);
      this.orderData.calfCircumferenceWithoutDeduction = 0;
      this.orderData.depth = 0;
    }

    skeletonRadius[0] = circumTop.floatValue;
    skeletonRadius[skeletonRadius.length - 1] = circumBottom.floatValue;
    const scale_factor = height.floatValue;
    const filename = this.selectedProductInput.treeData[0]?.name + '.obj';
    const outputType = 'base64';

    try {
      // Get Mesh item to deformation process...
      const blob = await this.getMeshCoversItem(isFullDeformation);

      if (!blob) {
        // Ensure blob is not a string
        this.isLoadingDeformation = false;
        return;
      }

      // Deformation process ...
      const data = await this.meshDeformationApi(
        blob,
        filename,
        skeletonRadius,
        scale_factor,
        outputType,
      );

      if (!data) {
        throw new Error('Deformation failed');
      }

      // Apply deformation result to meshEditor...
      // isFullDeformation ? await this.updateFullModel(data) : await this.updateSelectedModel(data);
      await this.updateFullModel(data);

    } catch (error) {
      console.error('Error updating 3D model:', error);
    } finally {
      this.productParameterEmbossing = false;
      this.isLoadingDeformation = false;
    }
  }

  isTypeBrace(productTypeId: number | null, productTypeName: string | null): boolean{
    return productTypeId === 215 || productTypeName?.toLowerCase() === 'brace';
  }

  //#endregion properties

  get meshHeight() {
    return this.orderData.heightWithoutDeduction;
    /*const num = this.selectedProductInput?.getSelection()[0]?.mesh?.scale?.y * 50;
     return Math.round(num * 100) / 100;*/
  }

  set meshHeight(value: number) {
    this.orderData.heightWithoutDeduction = value;
    /*this.selectedProductInput.treeData.forEach(function (data) {
       const mesh = data.mesh;
       mesh.scale.set(mesh.scale.x, value / 50, mesh.scale.z);
     });*/
  }

  get meshWidth() {
    return this.orderData.calfCircumferenceWithoutDeduction;
    /*const num = this.selectedProductInput?.getSelection()[0]?.mesh?.scale?.z * 50;
     return Math.round(num * 100) / 100;*/
  }

  set meshWidth(value: number) {
    this.orderData.calfCircumferenceWithoutDeduction = value;
    /*this.selectedProductInput.treeData.forEach(function (data) {
       const mesh = data.mesh;
       mesh.scale.set(mesh.scale.x, mesh.scale.y, value / 50);
     });*/
  }

  get meshCircumreference() {
    return this.orderData.ankleCircumference;
    /*const num = this.selectedProductInput?.getSelection()[0]?.mesh?.scale?.x * 50;
     return Math.round(num * 100) / 100;*/
  }

  set meshCircumreference(value: number) {
    this.orderData.ankleCircumference = value;
    /*this.selectedProductInput.treeData.forEach(function (data) {
       const mesh = data.mesh;
       mesh.scale.set(value / 50, mesh.scale.y, mesh.scale.z);
     });*/
  }

  get productTitle(): string {
    return removeWordFromString(this.orderData.coverModel, 'phase1');
  }

  // Helper function to get orderer information for covers
  private getOrdererInfo(): string {
    const { technicianFirstname, technicianLastname, technician, vgNumber, vsgNumber, customerNr, company, commissionNo, mail } = this.orderData;
    if (this.userStore.domain?.urlSuffix === 'luttermann') {
      return `
        ${this.locale.views.customize.workflow.form.orderer}: ${technicianFirstname + ' ' + technicianLastname}<br>
        ${this.locale.components['order-form'].technician}: ${technician}<br>
        ${this.locale.views.customize.workflow.form['vg-number']}: ${vgNumber}<br>
        ${this.locale.views.customize.workflow.form['vsg-number']}: ${vsgNumber}<br>
        ${this.locale.views.customize.workflow.form.customerNr}: ${customerNr}<br>
        ${this.locale.components['order-form'].mail}: ${mail}<br>
           `;
      } else {
      return `
        ${this.locale.views.customize.workflow.form.contactPerson}: ${technicianFirstname + ' ' + technicianLastname}<br>
        ${this.locale.views.customize.workflow.form.company}: ${company}<br>
        ${this.locale.views.customize.workflow.form.commissionNo}: ${commissionNo}<br>
        ${this.locale.components['order-form'].mail}: ${mail}<br>
           `;
      }
  }

  //#region pdf

  // Helper function to get product description for covers
  private getCoverDescription(bilateralAmputeeStatus: string, withZip: string): string {
    const { bodySide, kneeJoint, depth, heightWithoutDeduction, calfCircumferenceWithoutDeduction, bilateralAmputee, coverModel } = this.orderData;
    let description = '';

    if (bilateralAmputee === false) {
      description += `${this.locale.components['order-form'].bodySide}: ${this.locale.enum.bodySide[bodySide as keyof typeof this.locale.enum.bodySide]}<br>`;
      } else {
      description += `${this.locale.components['order-summary'].bilateralAmputee}: ${bilateralAmputeeStatus}<br>`;
      }

    description += `
      ${this.locale.components['order-form'].kneeJoint}: ${kneeJoint}<br>
      ${this.locale.components['order-form']['scope-top']}: ${depth}<br>
      ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
      ${this.locale.components['order-form']['scope-bottom']}: ${calfCircumferenceWithoutDeduction}<br>
           `;

    if (this.colorList.length > 1) {
      if (coverModel.toLowerCase().includes('x-cover')) {
        description += `${this.locale.components['order-summary'].embossing}: ${this.embossingList.join(', ')}<br>`;
        description += `${this.locale.components['order-summary'].baseColor}: ${this.colorList.join(', ')}<br>`;
      } else if (coverModel.toLowerCase().includes('flex')) {
        description += `${this.locale.components['order-summary'].baseColor}: ${this.colorList.slice(0, -1).join(', ')}<br>`;
        description += `${withZip}<br>`;
        description += `${this.locale.components['order-summary'].zipColor}: ${this.colorList[this.colorList.length - 1]}<br>`;
      }
    }

    return description;
  }

  // Helper function to get product description for other types
  private getProductDescription(): string {
    const productType = this.selectedModel?.product?.type.name.toLowerCase();
    const { balconyType, mountingType, paneelType, calfCircumferenceWithoutDeduction, heightWithoutDeduction, depth, bodySide, kneeJoint, foot, scanFiles } = this.orderData;
    const bilateralAmputeeStatus = this.orderData.bilateralAmputee ? this.locale.enum.bilateralAmputeeType.true : this.locale.enum.bilateralAmputeeType.false;
    const withZip = this.orderData.zip === 'yes' ? this.locale.enum.zipType.yes : this.locale.enum.zipType.no;

    switch (productType) {
      case 'balkone':
        return `
          ${this.locale.components['product-parameter'].balcony['carrying-out']}: ${this.locale.enum.balconyType[balconyType as keyof typeof this.locale.enum.balconyType]}<br>
          ${this.locale.components['product-parameter'].balcony['mounting-type']}: ${this.locale.enum.mountingType[mountingType as keyof typeof this.locale.enum.mountingType]}<br>
          ${this.locale.components['product-parameter'].balcony['paneel-type']}: ${this.locale.enum.paneelType[paneelType as keyof typeof this.locale.enum.paneelType]}<br>
          ${this.locale.components['order-form'].width}: ${calfCircumferenceWithoutDeduction}<br>
          ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
          ${this.locale.components['order-form'].depth}: ${depth}<br>
       `;
      case 'orthesen':
        if (this.selectedModel?.product.name.replace(/\s/g, '').toLowerCase().includes('phase1')) return '';
        const zip = ['u-flex', 'c-flex'].some(name => this.selectedModel?.product?.name?.toLowerCase().includes(name)) ? withZip : '';
        return `
          ${this.locale.components['order-form'].bodySide}: ${this.locale.enum.bodySide[bodySide as keyof typeof this.locale.enum.bodySide]}<br>
          ${this.locale.components['order-form'].kneeJoint}: ${kneeJoint} ${zip}<br>
          ${this.locale.components['order-form'].depth}: ${depth}<br>
          ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
          ${this.locale.components['order-form'].width}: ${calfCircumferenceWithoutDeduction}<br>
          ${this.locale.components['order-form'].foot}: ${foot}<br>
          ${this.locale.views.customize.workflow.form.scanFiles}: ${scanFiles.join(', ')}<br>
         ${this.locale.components['order-summary'].bilateralAmputee}: ${bilateralAmputeeStatus}<br>
       `;
      case 'brace':
        return `
          ${this.locale.components['order-form'].depth}: ${0}<br>
          ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
          ${this.locale.components['order-form'].width}: ${0}<br>
          ${this.locale.components['order-form'].foot}: ${foot}<br>
          ${this.locale.views.customize.workflow.form.scanFiles}: ${scanFiles.join(', ')}<br>
          ${this.locale.components['order-summary'].bilateralAmputee}: ${bilateralAmputeeStatus}<br>
        `;
      case 'möbel':
      case 'autos':
      case 'gebäude':
        return `
          ${this.locale.components['order-form'].width}: ${calfCircumferenceWithoutDeduction}<br>
          ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
          ${this.locale.components['order-form'].depth}: ${depth}<br>
       `;
      case 'zäune':
        return `
          ${this.locale.components['product-parameter'].fence['carrying-out']}: ${this.locale.enum.balconyType[balconyType as keyof typeof this.locale.enum.balconyType]}<br>
          ${this.locale.components['order-form'].width}: ${calfCircumferenceWithoutDeduction}<br>
          ${this.locale.components['order-form'].height}: ${heightWithoutDeduction}<br>
          ${this.locale.components['order-form'].depth}: ${depth}
        `;
      case 'lineare beleuchtung':
        return '';
      default:
        return '';
    }
  }

  downloadOfferPDF(): void {
    if (!this.selectedModel?.product) return;

    const productType = this.selectedModel.product.type.name.toLowerCase();
    const isCover = productType === 'covers';
    const bilateralAmputeeStatus = this.orderData.bilateralAmputee ? this.locale.enum.bilateralAmputeeType.true : this.locale.enum.bilateralAmputeeType.false;
    const withZip = this.orderData.zip === 'yes' ? this.locale.enum.zipType.yes : this.locale.enum.zipType.no;

    const imageLogo = this.authentication.primaryDomain?.logo ?? '';
    const title = this.locale.components['order-summary'].offer;
    const imageProduct = isCover ? '' : this.selectedModel.product.thumbnail.content;
    const productName = this.productTitle;
    const productPrice = this.workflowModel.totalPrice.toFixed(2);
    let ordererInfo = '';
    let productDescription = '';

    if (isCover) {
      ordererInfo = this.getOrdererInfo();
      productDescription = this.getCoverDescription(bilateralAmputeeStatus, withZip);
    } else {
      productDescription = this.getProductDescription();
    }

    const content = createPdfOfferTemplate(imageLogo, title, ordererInfo, imageProduct, productName, productPrice, productDescription, isCover);
    generatePDF(content, 'offer');
  }

  // Create Part List Pdf Content
  downloadPartListPDF(): void {
    if (!this.selectedModel?.product) return; // if the product does not exist, do not continue execution

    const imageLogo = this.authentication.primaryDomain?.logo ?? '';
    const title = this.locale.components['order-summary'].parts;
    const partList = Object.entries(this.meshGroupedPartItems).map((part) => {
      let label = '';

    const productType = this.selectedModel?.product.type.name.toLowerCase() ?? '';
    const partSelectionLocale = this.locale.components['part-selection'];

    if (productType === 'covers') {
      const localeKey = partSelectionLocale[productType]?.[part[0] as keyof typeof partSelectionLocale[typeof productType]];
      const itemCount = part[1].reduce((sum, current) => sum + current.cnt, 0);
      label = localeKey
        ? `${itemCount}x ${localeKey}`
        : `${part[1].length}x ${part[0]}`;
    } else {
      const productLocale = partSelectionLocale[productType as keyof typeof partSelectionLocale];
      const localeKey = typeof productLocale === 'object' && 'part' in productLocale && Array.isArray(productLocale.part) ? productLocale.part[0] : undefined;
      const itemCount = part[1].reduce((sum, current) => sum + current.cnt, 0);
      label = localeKey
        ? `${itemCount}x ${localeKey}`
        : `${part[1].length}x ${part[0]}`;
    }

      const parts = part[1].map((item) => {
        return {
          width: Math.ceil(item.meshTreeDataItem.size?.width ?? 0) + ' mm',
          height: Math.ceil(item.meshTreeDataItem.size?.height ?? 0) + ' mm',
          depth: Math.ceil(item.meshTreeDataItem.size?.depth ?? 0) + ' mm',
          cnt: item.cnt,
          basePrice: item.meshTreeDataItem.basePrice,
          totalPrice: item.cnt * item.meshTreeDataItem.basePrice,
          thumbnailUrl: item.meshTreeDataItem.thumbnailUrl,
        };
      });

      return { label, parts };
    });

    // Create html pdf template
    const content = createPdfPartListTemplate(imageLogo, title, partList);

    // Generate PDF
    generatePDF(content, 'part-list');
  }

  //#endregion pdf

  async onDeleteProduct(model: Model2) {
    ElMessageBox.confirm((this as any).$t('confirm.delete.message'), (this as any).$t('confirm.delete.title'), {
      confirmButtonText: (this as any).$t('enum.yesNoType.true'),
      cancelButtonText: (this as any).$t('enum.yesNoType.false'),
      type: 'warning',
    })
      .then(() => {
        ElMessageBox.confirm((this as any).$t('confirm.historyDelete.message'), (this as any).$t('confirm.historyDelete.title'), {
          confirmButtonText: (this as any).$t('confirm.delete.ok'),
          cancelButtonText: (this as any).$t('confirm.delete.cancel'),
          type: 'warning',
        })
          .then(() => {
            if (!this.userStore.user?.pk) {
              return;
            }
            const isSupplier = this.userStore.roles.includes(Role.Supplier);
            const deleteModelService = isSupplier
              ? modelService.deleteBaseModel(model.modelId, this.userStore.user?.pk)
              : modelService.deleteModel(model.modelId);
            deleteModelService.then(async (result) => {
              if (!result) {
                ElMessage.error((this as any).$t('error.api.delete'));
              } else {
                ElMessage.success((this as any).$t('success.api.delete'));

                const newProductList = this.productList.filter((p) => p.product.productId !== model.product.productId);
                this.productList = newProductList;
                try {
                  await FormBuilderService.deleteFormBuilderAzureFiles(model.product.productId);
                  FormBuilderService.deleteProductFormBuilder(model.product.productId)
                    .then((res) => {
                      console.log('deleted form builder status:', res);
                    })
                    .catch((err) => {
                      console.error('err', err);
                    });
                } catch (error) {
                  console.error('error delete formbuilder product', error);
                }

                // Delete video metadata from azure tables storage
                await deleteFileMetadataToAzureByProudctId(model.product.productId.toString());
              }
            });
          })
          .catch((err) => {
            console.error('err', err);
          });
      })
      .catch((err) => {
        console.error('err', err);
      });
  }

  getMeshColorPalettes(selection: MeshTreeDataItem | null = null): Palette[] {
    if (selection == null) {
      selection = this.getActivePart();
    }
    if (selection?.colors?.supportedValues) {
      return selection.colors.supportedValues;
    }
    return [];
  }

  getAllColors(treeData: MeshTreeDataItem | null = null) {
    if (treeData == null) {
      treeData = this.getActivePart();
    }
    const result: RGB[] = [];
    for (const colorCategory of this.getMeshColorPalettes(treeData)) {
      for (const color of colorCategory.supportedColors) {
        result.push(color);
      }
    }

    return result;
  }

  getMeshEngravings2(selection: MeshTreeDataItem | null = null): SupportedValues[] {
    if (selection == null) {
      selection = this.getActivePart();
    }
    if (selection?.engraving?.supportedValues) {
      const blankFile = selection.engraving.supportedValues.map((item) => item.thumbnail).find((th) => th?.name === 'blank');

      const supportedValues: SupportedValues[] = selection.engraving.supportedValues
        .map((item) => ({
          fileId: item.file.fileId,
          fileTextureId: item.fileTextureId,
          thumbnail: item.thumbnail?.name === 'blank' || item.thumbnail?.name === '' || item.thumbnail?.name === null ? blankFile : item.thumbnail,
        }));
      return supportedValues;
    }

    return [];
  }

  getMeshTextures2(selection: MeshTreeDataItem | null = null): SupportedValuesTextures[] {
    if (selection == null) {
      selection = this.getActivePart();
    }
    if (selection?.texture?.supportedValues) {
      const supportedValues: SupportedValuesTextures[] = selection.texture.supportedValues
        .map((item) => ({
          fileId: item.file.fileId,
          fileName: item.file.name,
          fileContent: item.file.content,
          fileTextureId: item.fileTextureId,
          thumbnail: item.file,
        }))
        .sort((a, b) => (a.fileName > b.fileName ? 1 : -1));
      return supportedValues;
    }
    return [];
  }

  getMeshEngravingColors(selection: MeshTreeDataItem | null = null): RGB[] {
    if (selection == null) {
      selection = this.getActivePart();
    }
    const texture = selection?.engraving?.supportedValues?.find((x) => x.file.fileId == this.selectedEmbossing);
    if (texture && texture.palette) {
      const colors: RGB[] = [];
      for (const color of texture.palette.supportedColors) {
        colors.push(color);
      }
      colors.unshift(this.transparentColorRgb);
      return colors;
    }
    return [];
  }

  getMeshTextureColors(selection: MeshTreeDataItem | null = null): RGB[] {
    if (selection == null) {
      selection = this.getActivePart();
    }
    const texture = selection?.texture?.supportedValues?.find((x) => x.file.fileId == this.selectedWtransfer);
    if (texture && texture.palette) {
      const colors: RGB[] = [];
      for (const color of texture.palette.supportedColors) {
        colors.push(color);
      }
      return colors;
    }
    return [];
  }

  get isAutomaticScanActive(): boolean {
    return this.selectedScan != null && this.selectedSkeleton != null && this.selectedScan.fileId != null && this.selectedSkeleton.fileId != null;
  }

  created(): void {
    window.addEventListener('resize', this.resize);

    const token = Cookies.get(Key.cookie.access_token_key);
    if (!token) {
      this.router.push('/login');
    }
  }

  resize(): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  async showComponentsModalDialog(model: Model2 | null): Promise<void> {
    if (model !== null) {
      this.selectedModel = model;
    }

    if (this.componentsModalDialog) {
      this.componentsModalDialog.show();
    }
  }

  show3DView(model: Model2): void {
    this.handleSelectProduct(model);
    this.workflowModel.setStep(3);
  }

  hideProductParameterModalDialog(): void {
    this.productParameterModalDialog.hide();
  }

  async handleShowMeshEditor(model: Model2, selectedBodyAttribute?: { scanFile: UtilityFile | null; skeleton: UtilityFile | null }): Promise<void> {
    // If product type name not equal 'covers' open product paramter modal
    if (model.product.type.name.toLocaleLowerCase() !== 'covers' && !this.productParameterModalDialog._isShown) {
      await this.showProductParameterModalDialog(model);
      return;
    }

    if (this.productParameterEmbossing) {
      // If parameter embossing ready. Call function update mesh
      this.update3DModel();
    } else {
      // Open mesh Editor
      this.hideProductParameterModalDialog();
      this.selectedScan = selectedBodyAttribute?.scanFile || null;
      this.selectedSkeleton = selectedBodyAttribute?.skeleton || null;
      this.handleSelectProduct(model);
      this.workflowModel.OnClickNextAction(1);
    }
  }

  loadFromDB(): void {
    this.selectedProductInput.clear();
    this.selectedProductInput2.clear();
    this.meshEditorLoading = true;

    if (this.selectedModelId) {
      if (this.isAutomaticScanActive) {
        modelService
          .automaticAdaption(
            this.selectedModel!.product.productId,
            this.selectedScan!.fileId!,
            this.selectedSkeleton!.fileId!,
            {
              height: this.orderData.heightWithoutDeduction,
              depth: this.orderData.depth,
              width: 0,
            } as UtilitySize,
            0.0,
            false,
            this.productQualityToInt(this.selectedProductQuality),
            Side[this.orderData.bodySide as keyof typeof Side]
          )
          .then(async (model) => {
            this.selectedModel = model;
            this.selectedModelId = model.modelId;
            await this.loadScan();
            this.loadTemplate(model);
          });
      } else if (this.selectedModel?.product.type?.name?.toLowerCase() == 'balkone') {
        this.generateBalconyModel();
      } else if (this.selectedModel?.product.type?.name?.toLowerCase() == 'fence') {
        this.generateFenceSunModel();
      } else if (this.selectedModel?.product.type?.name?.toLowerCase() == 'zäune') {
        this.generateFenceModel();
      } else if (this.selectedModel?.product.name.toLowerCase() == 'abgehängt') {
        this.generateSuspendedLightModel();
      } else if (this.selectedModel?.product.type?.name?.toLowerCase() == 'duschen und bäder') {
        this.generateBathtubModel();
      } else {
        this.loadTemplateFromDB();
      }
    }
  }

  loadTemplateFromDB(controller?: AbortController): void {
    this.meshEditorLoading = true;
    const usedController = controller || this.abortController;
    this.selectedProductInput.clear();
    this.selectedProductInput2.clear();
    TemplateService.getTemplateData(this.selectedModelId!, ProductQuality[this.selectedProductQuality as keyof typeof ProductQuality], usedController)
      .then((templateData) => {
        this.loadTemplate(templateData);
        this.loadTemplate2(templateData);
      })
      .catch((err) => {
        if (err.name === 'AbortError') {
          this.meshEditorLoading = false;
          return;
        }
        // For other errors
        this.meshEditorLoading = false;
      });
  }

  loadTemplate(templateData: Model2) {
    this.meshEditorLoading = true;
    if (this.selectedModelId) {
      this.selectedModel = templateData;
      if (templateData && templateData?.components?.length > 0) {
        const loadChildren = (parent: string | MeshTreeDataItem | null, children: Component1[]): void => {
          for (const child of children) {
            const level = Object.keys(ProductQuality).indexOf(this.selectedProductQuality);
            const data = modelService.parseToMeshExportData(child, child.resolutions[level] ?? child.resolutions[0]);
            let treeData!: MeshTreeDataItem;
            if (data.fileType !== FileType3D.NONE) {
              treeData = this.selectedProductInput.addBase64Import(
                data.uniqueKey,
                data.componentId,
                data.name,
                data.fileType,
                data.base64,
                data.thumbnailType,
                data.thumbnail,
                parent,
                false,
                data.color,
                data.position,
                data.rotation,
                data.scale
              );
              treeData.bones = data.bones.map((boneInfo) => {
                const bone = new THREE.Bone();
                bone.name = boneInfo.name;
                bone.position.copy(boneInfo.position);
                return bone;
              });
            } else {
              treeData = this.selectedProductInput.addGroup(
                data.name,
                [],
                data.position,
                data.rotation,
                data.scale,
                parent ? parent : (this as any).$t(`enum.upload-category.${data.category}`),
                false
              );
              treeData.id = data.uniqueKey;
            }
            loadChildren(
              treeData,
              templateData.components.filter((item) => item.parent?.uuid === data.uniqueKey)
            );
          }
        };
        loadChildren(
          null,
          templateData.components.filter((item) => item.parent === null)
        );

        if (this.loadedScan) {
          loadChildren(null, [this.loadedScan]);
        }
      }
    }
    //this.meshEditorLoading = false;
    //this.loadAllAttributeListDB();
    this.attrLoadPromise = this.loadAllAttributeListDB();
  }

  async loadTemplate2(templateData: Model2) {
    this.meshEditorLoading = true;
    if (this.selectedModelId) {
      this.selectedModel = templateData;
      if (templateData && templateData?.components?.length > 0) {
        const loadChildren = (parent: string | MeshTreeDataItem | null, children: Component1[]): void => {
          for (const child of children) {
            const level = Object.keys(ProductQuality).indexOf(this.selectedProductQuality);
            const data = modelService.parseToMeshExportData(child, child.resolutions[level] ?? child.resolutions[0]);
            let treeData!: MeshTreeDataItem;
            if (data.fileType !== FileType3D.NONE) {
              treeData = this.selectedProductInput2.addBase64Import(
                data.uniqueKey,
                data.componentId,
                data.name,
                data.fileType,
                data.base64,
                data.thumbnailType,
                data.thumbnail,
                parent,
                false,
                data.color,
                data.position,
                data.rotation,
                data.scale
              );
              treeData.bones = data.bones.map((boneInfo) => {
                const bone = new THREE.Bone();
                bone.name = boneInfo.name;
                bone.position.copy(boneInfo.position);
                return bone;
              });
            } else {
              treeData = this.selectedProductInput2.addGroup(
                data.name,
                [],
                data.position,
                data.rotation,
                data.scale,
                parent ? parent : (this as any).$t(`enum.upload-category.${data.category}`),
                false
              );
              treeData.id = data.uniqueKey;
            }
            loadChildren(
              treeData,
              templateData.components.filter((item) => item.parent?.uuid === data.uniqueKey)
            );
          }
        };
        loadChildren(
          null,
          templateData.components.filter((item) => item.parent === null)
        );

        if (this.loadedScan) {
          loadChildren(null, [this.loadedScan]);
        }
      }
    }
    const requestOptions: RequestInit = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    try {
      const apiUrl = import.meta.env.VITE_MODELLING_API_URL;
      let response: Response;
      let rotation = new THREE.Euler(0, 0, 0);
      let position = new THREE.Vector3(0, 0, -300);
      if (this.selectedModel?.product?.name?.toLowerCase().includes('prothesenschaft')){
        response = await fetch(`${apiUrl}/lower_template_leg`, requestOptions);
        position = new THREE.Vector3(-75, -200, -300);
      }else{
        response = await fetch(`${apiUrl}/template_leg`, requestOptions);
      }

      const result = await response.json();

      this.updateFullModel(result)

      this.templateMesh = this.selectedProductInput2.addBase64Import(
        'template-mesh',
        null,
        'Template Mesh',
        FileType3D.OBJ,
        result.template_mesh,
        FileTypeImage.JPG,
        "",
        null,
        false,
        '#ffc3a0',
        position,
        rotation,
        new THREE.Vector3(1, 1, 1)
      );
      this.selectedProductInput2.updateStructure(); // Refresh the viewer
    }
    catch (error) {
      console.error('API error:', error);
    }

    waitFor(() => !this.meshEditorLoading).then(() => {
      this.loadAllAttributeListDB();
    });
  }

  updateMeshInViewer(mesh: string){
    let position = new THREE.Vector3(0, 0, -300);
    let rotation = new THREE.Euler(0, 0, 0);
    if (this.selectedModel?.product?.name?.toLowerCase().includes('prothesenschaft')){
        position = new THREE.Vector3(-75, -200, -300);
    }
    if(this.templateMesh){
      this.selectedProductInput2.removeItem(this.templateMesh);
      this.selectedProductInput2.updateStructure();
      this.templateMesh = this.selectedProductInput2.addBase64Import(
        'template-mesh',
        null,
        'Template Mesh',
        FileType3D.OBJ,
        mesh,
        FileTypeImage.JPG,
        "",
        null,
        false,
        '#ffc3a0',
        position,
        rotation,
        new THREE.Vector3(1, 1, 1)  // scale (optional)
      );
      this.selectedProductInput2.updateStructure(); // Refresh the viewer
      this.isLoadingDeformation = false;
    } else {
      console.error("No template mesh found to update in viewer");
    }
  }

  privacyChanged(): void {
    if (this.orderData.isPrivacy) {
      this.orderData.privacy = 'yes';
    } else {
      this.orderData.privacy = '';
    }
  }

  componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length == 1 ? '0' + hex : hex;
  }

  rgbToHexString(value: RGB): string {
    return '#' + this.componentToHex(value.red) + this.componentToHex(value.green) + this.componentToHex(value.blue);
  }

  get productCount(): number {
    return this.productDB.length;
  }

  get productPagesCount(): number {
    return Math.ceil(this.modelList.length / this.productsPerPage);
  }

  @Watch('window.innerWidth', { immediate: true })
  getProductsForPage(page: number): Model2[] {
    return this.modelList.slice((page - 1) * this.productsPerPage, page * this.productsPerPage);
  }

  get productsPerPage(): number {
    return 50;
  }

  @Watch('selectedProductInput.lastUpdateVisibility', { immediate: true })
  selectionChanged(): void {
    const selection = this.selectedProductInput.getSelection();
    const componentIDs = selection.map((d) => d.componentId).filter((id): id is number => id !== null);

    if (componentIDs.length > 0) {
      this.settingStore.setActiveID(componentIDs[0]);
    }
  }

  async loadAllAttributeListDB(): Promise<void> {
    this.embossingDB.length = 0;

    const items = [...this.selectedProductInput.treeData];

    await Promise.all(items.map(async (component) => {
      this.colorListLoading.set(component.uuid, false);
      await this.loadColorListDB(component);

      this.embossingListLoading.set(component.uuid, false);
      await this.loadEmbossingListDB(component);

      this.wtransferListLoading.set(component.uuid, false);
      await this.loadWtransferListDB(component);

      this.sizeListLoading.set(component.uuid, false);
      await this.loadSizeListDB(component);
    }));
  }


  async refetchEmbossingListDB() {
    for (const component of this.selectedProductInput.treeData) {
      this.loadEmbossingListDB(component, true);
    }
  }

  async refetchWTransferListDB() {
    for (const component of this.selectedProductInput.treeData) {
      this.loadWtransferListDB(component, true);
    }
  }

  async loadEmbossingListDB(component: MeshTreeDataItem | null = null, shouldRefetch = false): Promise<void> {
    this.embossingDB.length = 0;
    if (component == null) {
      component = this.getActivePart();
    }
    if (
      (component && component.componentId && !component.engraving && !this.embossingListLoading.get(component.uuid)) ||
      (shouldRefetch && component && component.componentId)
    ) {
      const engraving = await TemplateService.getEmbossingData(component.componentId, shouldRefetch);
      if (engraving) {
        component.engraving = engraving;
        if (component.engraving?.engravingFile) {
          this.handleSelectEmbossing(component.engraving?.engravingFile, component);
        }
        this.embossingListLoading.set(component.uuid, true);
      } else {
        if (component) this.embossingListLoading.set(component.uuid, false);
      }
    }
  }

  async loadColorListDB(component: MeshTreeDataItem | null = null): Promise<void> {
    this.embossingDB.length = 0;
    if (component == null) {
      component = this.getActivePart();
    }
    if (component && component.componentId && !component.colors && !this.colorListLoading.get(component.uuid)) {
      const colors = await TemplateService.getColorData(component.componentId);
      if (colors) {
        component.colors = colors;
        if (component.colors?.value) {
          this.colorizeSingleMesh(component.colors?.value, component);
        }
        this.colorListLoading.set(component.uuid, true);
      } else {
        if (component) this.colorListLoading.set(component.uuid, false);
      }
    }
  }

  async loadSizeListDB(component: MeshTreeDataItem | null = null): Promise<void> {
    this.embossingDB.length = 0;
    if (component == null) {
      component = this.getActivePart();
    }
    if (component && component.componentId && !component.size && !this.sizeListLoading.get(component.uuid)) {
      const size = await TemplateService.getSizeData(component.componentId);
      if (size) {
        component.size = size;
        this.sizeListLoading.set(component.uuid, true);
      } else {
        if (component) this.sizeListLoading.set(component.uuid, false);
      }
    }
  }

  async loadWtransferListDB(component: MeshTreeDataItem | null = null, shouldRefetch = false): Promise<void> {
    this.wtransferDB.length = 0;
    if (component == null) {
      component = this.getActivePart();
    }
    if (
      (component && component.componentId && !component.texture && !this.wtransferListLoading.get(component.uuid)) ||
      (shouldRefetch && component && component.componentId)
    ) {
      const texture = await TemplateService.getTextureData(component.componentId, shouldRefetch);
      if (texture) {
        component.texture = texture;
        if (component.texture?.textureFile) {
          this.handleSelectWtransfer(component.texture.textureFile, component);
        }
        this.wtransferListLoading.set(component.uuid, true);
      } else {
        if (component) {
          this.wtransferListLoading.set(component.uuid, false);
        }
      }
    }
  }

  //#endregion load

  //#region selection
  async handleSelectProduct(model: Model2 | null): Promise<void> {
    if (model) {
      this.selectedModelId = model.modelId;
      this.selectedModel = model;
      this.loadFromDB();
      this.isSidebarRight = true;
    } else {
      this.isSidebarRight = false;
      this.selectedProductId = '';
      this.selectedProductInput.clear();
      const troisRenderer: any = this.$refs.troisRenderer;
      const three = troisRenderer.three;
      cleanUpScene(three.scene);
    }
  }

  get hasSelectedMesh(): boolean {
    for (const item of this.selectedProductInput.treeData) {
      if (item.isSelected) {
        return true;
      }
    }
    return false;
  }

  get selectedName(): string {
    if (this.selectedModel?.product) {
      return this.selectedModel.product?.name;
    }
    return '';
  }

  get selectedConfig(): ProductConfig | null {
    const product = this.productDB.find((item) => item.id === this.selectedProductId);
    if (product) {
      const filename = product.mesh[0].filename;
      const name = product?.name;
      const config = this.productConfigurationDB.find((item) => item.meshes[0].filename === filename && item?.name === name);
      if (config) return config;
    }
    return null;
  }

  getActivePart(): MeshTreeDataItem | null {
    const selection = this.selectedProductInput.getSelection();
    /*const data =
       selection.length > 0 ? selection : this.selectedProductInput.treeData;*/
    if (selection.length > 0) return selection[0];
    return null;
  }
  //#endregion selection

  get selectedColor(): RGB | null {
    const treeData = this.getActivePart();
    if (treeData) {
      if (treeData.colors) return treeData.colors.value;
    }
    return null;
  }

  colorizeSelectedMesh(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    } 
    if (this.selectedModel?.product?.type?.name?.toLowerCase() == 'balkone' || this.selectedModel?.product?.type?.name?.toLowerCase() == 'zäune') {
      this.colorizeMultipleMeshes(color, treeData);
    } else if (this.selectedProductInput.treeData.some((meshTreeData) => meshTreeData?.name === 'Reißverschluss')) {
      this.colorizeCoverAndZipper(color, treeData);
    } else {
      this.colorizeSingleMesh(color, treeData);
    }
  }

  getEuclideanDistance(color1: RGB, color2: RGB): number {
    return Math.sqrt(Math.pow(color1.red - color2.red, 2) + Math.pow(color1.green - color2.green, 2) + Math.pow(color1.blue - color2.blue, 2));
  }

  getBestMatchingZipperColor(coverColor: RGB, supportedColors: RGB[]): RGB {
    const name = coverColor.name.toLowerCase();
    const earthy = ['brown', 'beige', 'ochre'];

    if (earthy.some(term => name.includes(term))) {
      return supportedColors.filter(c => c.name === 'beige')[0];
    }
    else if(name.includes('grey')) {
      return supportedColors.filter(c => c.name === 'gray')[0];
    }

    let bestMatch = supportedColors[0];
    let minDistance = this.getEuclideanDistance(coverColor, bestMatch);
    for (const zipperColor of supportedColors) {
      const distance = this.getEuclideanDistance(coverColor, zipperColor);
      if (distance < minDistance) {
        bestMatch = zipperColor;
        minDistance = distance;
      }
    }

    return bestMatch;
  }

  colorizeCoverAndZipper(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (treeData && color) {
      const zipper = this.selectedProductInput.treeData.find((meshTreeData) => meshTreeData?.name === 'Reißverschluss');
      const supportedValues = zipper?.colors?.supportedValues[0].supportedColors;
      if (supportedValues && supportedValues.length > 0) {
        if (!this.getActivePart()?.name.includes('Oberteil')) {
          this.bestMatchingZipperColor = this.getBestMatchingZipperColor(color, supportedValues);
        }
        const activeId = this.settingStore.getActiveID();
        this.settingStore.setActiveID(zipper.componentId!);
        this.settingStore.saveConfig({ color: this.bestMatchingZipperColor.name });
        this.settingStore.setActiveID(activeId!);
        this.colorizeSingleMesh(this.bestMatchingZipperColor, zipper);
        this.colorizeSingleMesh(color, treeData);
      }
    }
  }

  colorizeMultipleMeshes(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (treeData && color) {
      this.colorizeSingleMesh(color, treeData);
      for (const meshTreeData of this.selectedProductInput.treeData) {
        if (meshTreeData?.name.startsWith(treeData?.name.split(' ')[0])) {
          this.colorizeSingleMesh(color, meshTreeData);
        }
      }
    }
  }

  colorizeSingleMesh(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    treeData ??= this.getActivePart();
    if (!treeData || !color) return;

    treeData.color = this.rgbToHexString(color);
    this.updatePaletteColor(treeData, color);
    this.applyMaterialOrEmbossing(treeData, color);
    this.handleTextureTransfer(treeData);

    const activeId = this.settingStore.getActiveID();
    this.settingStore.setActiveID(treeData?.componentId!);
    const activeColor = getComponentSettings(activeId!)?.color;
    // const embossingColor = getComponentSettings(activeId!)?.embossingColor;

    if (activeColor == null || activeColor == undefined) {
      this.settingStore.saveConfig({ color: color.name });
    }

    // this line of code effects that the default color will be only set for one component in the local storage
    // this.settingStore.setActiveID(activeId!);
  }

  private updatePaletteColor(treeData: MeshTreeDataItem, color: RGB): void {
    const palette = treeData.colors?.supportedValues
      .find((x) => x.supportedColors.find((y) => y?.name === color?.name));

    if (!palette) return;

    treeData.colors!.value = color;
    this.workflowModel.setStepPrice(
      treeData.id!,
      Object.keys(CustomizeProgress).indexOf(CustomizeProgress.visual),
      0
    );
  }

  private applyMaterialOrEmbossing(treeData: MeshTreeDataItem, color: RGB): void {
    if (!treeData.engraving) {
      if (treeData.mesh instanceof THREE.Mesh) {
        (treeData.mesh.material as THREE.MeshPhongMaterial).vertexColors = false;
      }
      THREEMaterial.setColor(treeData.mesh, this.rgbToHexString(color));
    } else {
      const engravingColor = treeData.engraving.engravingColor || this.transparentColorRgb;
      this.colorizeSelectedEmbossing(engravingColor, treeData);
    }
  }

  private handleTextureTransfer(treeData: MeshTreeDataItem): void {
    if (treeData.texture?.transparent) {
      this.handleSelectWtransfer(treeData.texture.textureFile, treeData);
    } else {
      this.handleSelectWtransfer(null);
    }
  }
  //#endregion color

  //#region embossing
  set selectedEmbossing(id: number | null) {
    const treeData = this.getActivePart();
    if (treeData) {
      treeData.engravingId = id;
    }
  }

  get selectedEmbossing(): number | null {
    const treeData = this.getActivePart();
    if (treeData) {
      if (treeData.engravingId) return treeData.engravingId;
    }
    return null;
  }

  async handleSelectEmbossing(fileOrFileTextureId: UtilityFile | number | null, treeData: MeshTreeDataItem | null = null): Promise<void> {
    if (!treeData) {
      treeData = this.getActivePart();
    }

    let file: UtilityFile | null = null;

    if (typeof fileOrFileTextureId === 'number') {
      file = await TemplateService.getEngravingFile(fileOrFileTextureId);
    } else {
      file = fileOrFileTextureId;
    }

    if (file) {
      this.selectedEmbossing = file.fileId;
      const embossingUrl = await this.selectedEmbossingUrl(this.selectedEmbossing!);

      new THREE.TextureLoader().load(file.content, (bmap) => {
        if (treeData) {
          const color = treeData.color ? treeData.color : '#ffffff';
          treeData.engravingId = file!.fileId;
          treeData.embossing = this.selectedEmbossingName;
          treeData.embossingThumbnailUrl = this.selectedEmbossingThumbnailUrl;
          treeData.embossingUrl = embossingUrl;
          if (treeData.engraving) {
            treeData.engraving.engravingFile = file;
            const isBlank = file!.name == this.blankFileName;
            this.workflowModel.setStepPrice(treeData.id!, Object.keys(CustomizeProgress).indexOf(CustomizeProgress.visual), 0);
          }

          treeData.material = new THREE.MeshPhongMaterial({
            color: color ?? 0xf1dcbc,
            shininess: 5,
            bumpMap: bmap,
            bumpScale: 1.2,
            specular: new THREE.Color(0x444444), // controls highlight color
          });

          let embossingColor = this.transparentColorRgb;
          if (treeData.engraving?.engravingColor && this.getMeshEngravingColors().find((m) => m.name == treeData?.engraving?.engravingColor?.name)) {
            embossingColor = treeData.engraving?.engravingColor;
          }
          this.colorizeSelectedEmbossing(embossingColor, treeData);

          this.handleSelectWtransfer(null);
        }
        //this.meshEditorLoading = false;
      });
    } else {
      this.selectedEmbossing = null;
      if (treeData) {
        treeData.engravingId = null;
        treeData.embossing = null;
        treeData.embossingThumbnailUrl = null;
      }
    }
  }

  get selectedEmbossingThumbnailUrl(): string {
    const selectedSupportValue = this.getMeshEngravings2().find((item) => item.fileId === this.selectedEmbossing);
    if (selectedSupportValue && selectedSupportValue.thumbnail && selectedSupportValue.thumbnail.content) {
      return selectedSupportValue!.thumbnail!.content!;
    }
    return '';
  }

  async selectedEmbossingUrl(selectedEmbossing: number): Promise<string> {
    try {
      if (selectedEmbossing) {
        const selection = await TemplateService.getFile(selectedEmbossing);
        if (selection) {
          this.selectedEmbossingContent = selection.content;
        } else {
          console.error('Error: File selection is null');
        }
        return selection.content;
      } else {
        console.error('Error: No support value found for the selected embossing');
        return '';
      }
    } catch (error) {
      console.error('Error fetching selected embossing thumbnail URL:', error);
      return '';
    }
  }

  get selectedEmbossingName(): string {
    const selectedSupportValue = this.getMeshEngravings2().find((item) => item.fileId === this.selectedEmbossing);

    if (selectedSupportValue) {
      return selectedSupportValue.thumbnail!.name;
    }
    return '';
  }
  //#endregion embossing

  //#region wtransfer
  set selectedWtransfer(id: number | null) {
    const treeData = this.getActivePart();
    if (treeData) {
      treeData.textureId = id;
    }
  }

  get selectedWtransfer(): number | null {
    const treeData = this.getActivePart();
    if (treeData) {
      if (treeData.textureId) return treeData.textureId;
    }
    return null;
  }

  async handleSelectWtransfer(file: UtilityFile | null, treeData: MeshTreeDataItem | null = null): Promise<void> {
    if (!treeData) {
      treeData = this.getActivePart();
    }

    await this.handleSingleWtransfer(file, treeData);
  }

  async handleMultipleWtransfer(fileOrFileTextureId: UtilityFile | number | null, treeData: MeshTreeDataItem | null = null): Promise<void> {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    let file: UtilityFile | null = null;

    if (typeof fileOrFileTextureId === 'number') {
      file = await TemplateService.getEngravingFile(fileOrFileTextureId);
    } else {
      file = fileOrFileTextureId;
    }

    if (treeData && file) {
      await this.handleSingleWtransfer(file, treeData);
      for (const meshTreeData of this.selectedProductInput.treeData) {
        if (meshTreeData.name.startsWith(treeData.name.split(' ')[0])) {
          await this.handleSingleWtransfer(file, meshTreeData);
        }
      }
    }
  }

  async handleSingleWtransfer(file: UtilityFile | null, treeData: MeshTreeDataItem | null = null): Promise<void> {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (file && file.fileId) {
      const selectedWtransferUrl = await this.selectedWtransferUrl(file.fileId);

      let color = { red: 255, green: 255, blue: 255 } as RGB;
      new THREE.TextureLoader().load(file.content, (bmap) => {
        if (file.name.toLowerCase().includes('bathtub')) {
          bmap.center.set(0.5, 0.5);
          bmap.rotation = Math.PI / 2;
          bmap.wrapS = bmap.wrapT = THREE.RepeatWrapping;
          bmap.repeat.set(0.1, 0.1);
        }

        if (treeData) {
          treeData.textureId = file.fileId;
          treeData.wtransfer = this.selectedWtransferName;
          treeData.wtransferUrl = selectedWtransferUrl;

          if (treeData.texture) {
            treeData.texture.textureFile = file;
            if (this.getMeshTextureColors().length > 0) {
              if (treeData.texture.textureColor) {
                color = treeData.texture.textureColor;
              } else {
                color = this.getMeshTextureColors()[0];
              }
              treeData.texture.textureColor = color;
            }

            const texture = treeData?.texture?.supportedValues?.find((x) => x.file.fileId == this.selectedWtransfer);

            if (texture) {
              this.workflowModel.setStepPrice(
                treeData.id!,
                Object.keys(CustomizeProgress).indexOf(CustomizeProgress.visual),
                treeData.basePrice * (texture.palette ? texture.palette.additionalPrice : 0)
              );
            }

            this.workflowModel.setStepPrice(
              treeData.id!,
              Object.keys(CustomizeProgress).indexOf(CustomizeProgress.visual),
              treeData.texture.additionalPrice
            );
          }

          if (treeData.texture?.transparent) {
            if (treeData.colors?.value) color = treeData.colors.value;
            treeData.material = new THREE.MeshPhysicalMaterial({
              color: new Color(this.rgbToHexString(color)),
              roughness: 0.02,
              transmission: 0.5,
              metalness: 0.1,
              transparent: true,
              opacity: 0.6,
              map: bmap, // Textur auf das Material anwenden
            });
          } else {
            treeData.material = new THREE.MeshPhongMaterial({
              color: new Color(this.rgbToHexString(color)),
              shininess: 20,
              map: bmap, // Textur auf das Material anwenden
            });
          }

          (treeData.mesh as THREE.Mesh).material = treeData.material;

          this.handleSelectEmbossing(null);
        }
      });
    } else {
      this.selectedWtransfer = null;
      if (treeData) {
        treeData.wtransferId = null;
        treeData.wtransfer = null;
        treeData.wtransferUrl = null;
      }
    }
  }

  abortCurrentRequest() {
    if (this.abortController) {
      this.abortController.abort();
      this.meshEditorLoading = false;
    }
  }

  colorizeSelectWtransfer(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (this.selectedModel?.product?.type?.name?.toLowerCase() == 'balkone' || this.selectedModel?.product?.type?.name?.toLowerCase() == 'zäune') {
      this.colorizeMultipleWtransfer(color, treeData);
    } else {
      this.colorizeSingleWtransfer(color, treeData);
    }
  }

  colorizeSingleWtransfer(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (treeData && treeData.texture) {
      treeData.texture.textureColor = color;
      (treeData.material as THREE.MeshPhongMaterial).color = new Color(this.rgbToHexString(color));
      (treeData.mesh as THREE.Mesh).material = treeData.material;
    }
  }

  colorizeMultipleWtransfer(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    if (treeData && color) {
      this.colorizeSingleWtransfer(color, treeData);
      for (const meshTreeData of this.selectedProductInput.treeData) {
        if (meshTreeData.name.startsWith(treeData.name.split(' ')[0])) {
          this.colorizeSingleWtransfer(color, meshTreeData);
        }
      }
    }
  }

  /*get selectedWtransferUrl(): string {
     const selection = this.getMeshTextures2().find(
       (item) => item.fileId === this.selectedWtransfer
     );
     if (selection) {
       return selection.content;
     }
     return '';
   }*/
  async selectedWtransferUrl(selectedWtransfer: number): Promise<string> {
    try {
      if (selectedWtransfer) {
        const selection = await TemplateService.getFile(selectedWtransfer);
        if (selection) {
          return selection.content;
        } else {
          console.error('Error: File selection is null');
          return '';
        }
      } else {
        console.error('Error: No support value found for the selected embossing');
        return '';
      }
    } catch (error) {
      console.error('Error fetching selected embossing thumbnail URL:', error);
      return '';
    }
  }

  get selectedWtransferName(): string {
    const selection = this.getMeshTextures2().find((item) => item.fileId === this.selectedWtransfer);
    if (selection && selection.thumbnail) {
      return selection.thumbnail.name;
    }
    return '';
  }
  //#endregion wtransfer

  set selectedEmbossingColor(color: RGB | null) {
    const treeData = this.getActivePart();
    if (treeData?.engraving) {
      treeData.engraving.engravingColor = color;
    }
  }

  get selectedEmbossingColor(): RGB | null {
    const treeData = this.getActivePart();
    if (treeData) {
      if (treeData.engraving) return treeData.engraving.engravingColor;
    }
    return null;
  }

  set selectedTextureColor(color: RGB | null) {
    const treeData = this.getActivePart();
    if (treeData?.texture) {
      treeData.texture.textureColor = color;
    }
  }

  get selectedTextureColor(): RGB | null {
    const treeData = this.getActivePart();
    if (treeData) {
      if (treeData.texture) return treeData.texture.textureColor;
    }
    return null;
  }

  set selectedVarnish(varnish: string) {
    this.orderData.varnish = varnish;
  }

  get selectedVarnish(): string {
    return this.orderData.varnish;
  }

  colorizeSelectedEmbossing(color: RGB, treeData: MeshTreeDataItem | null = null): void {
    if (!treeData) {
      treeData = this.getActivePart();
    }
    this.selectedEmbossingColor = color;

    if (treeData) {
      if (treeData.engraving) {
        treeData.engraving.engravingColor = color;
        const texture = treeData?.engraving?.supportedValues?.find((x) => x.file.fileId == this.selectedEmbossing);

        this.workflowModel.setStepPrice(
          treeData.id!,
          Object.keys(CustomizeProgress).indexOf(CustomizeProgress.overview),
          treeData.engraving.engravingColor && treeData.engraving.engravingColor != this.transparentColorRgb && texture?.palette?.additionalPrice
            ? texture.palette.additionalPrice
            : 0
        );
      }
      if (color.name == this.transparentColorRgb.name && treeData.colors?.value) {
        color = treeData.colors.value;
      }

      const url = treeData.embossingUrl;
      if (url == null) return;

      //this.meshEditorLoading = true;
      new THREE.ImageLoader().load(url, (image) => {
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;

        const context = canvas.getContext('2d');
        if (!context) return;

        context.drawImage(image, 0, 0);
        const imgData = context.getImageData(0, 0, canvas.width, canvas.height);

        const data = imgData.data;
        const limitValue = 100;

        let selColor: RGB | null = null;
        if (treeData?.colors?.value) {
          selColor = treeData.colors.value;
        }

        for (let i = 0; i < data.length; i += 4) {
          if (data[i] >= limitValue && data[i + 1] >= limitValue && data[i + 2] >= limitValue) {
            data[i] = selColor ? selColor.red : 255;
            data[i + 1] = selColor ? selColor.green : 255;
            data[i + 2] = selColor ? selColor.blue : 255;
          } else {
            data[i] = color.red;
            data[i + 1] = color.green;
            data[i + 2] = color.blue;
          }
        }

        context.putImageData(imgData, 0, 0);
        const map = new THREE.CanvasTexture(context.canvas);
        if (treeData) {
          (treeData.material as THREE.MeshPhongMaterial).color = new Color('#ffffff');
          (treeData.material as THREE.MeshPhongMaterial).map = map;
          (treeData.mesh as THREE.Mesh).material = treeData.material;
        }

        //this.meshEditorLoading = false;
      });
    }
  }

  //#region form
  dialogImageUrl: UploadData | null = null;
  dialogVisible = false;

  handlePictureCardPreview(uploadFile: UploadData | null): void {
    if (uploadFile)
      this.dialogImageUrl = {
        name: uploadFile.name,
        url: uploadFile.url,
        uid: uploadFile.uid,
      };
    this.dialogVisible = true;
  }

  async showProductParameterModalDialog(model: Model2 | null, isEmbossing?: boolean): Promise<void> {
    if (model !== null && model !== undefined) {
      this.selectedModel = model;
      // Get video metadata from Azure Tables Storage ...
      try {
        const videoTypes = Object.values(FileTypeVideo)
        const product = model.product as any
        const video = (product?.videos ?? []).find((video: { type: FileTypeVideo; }) => videoTypes.includes(video.type));
        if (video)
          this.videoMetadata = {
            ...this.videoMetadata,
            filename: video?.name ?? '',
            fileUrl: video.content ?? '',
            fileType: video.type ?? '',
          };
      } catch (error) {
        console.error('error find product video', error)
      }
    }

    this.productParameterModalDialog.show();
    this.productParameterEmbossing = Boolean(isEmbossing);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadFile(file: File, list: UploadData[]): boolean {
    const url = URL.createObjectURL(file);
    fileContentToBase64(file, (encodeString) => {
      const data = {
        name: file.name,
        url: url,
        uid: file.lastModified,
        base64: encodeString,
      };
      list.pop();
      list.push(data);
    });
    return true;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadFileDesignFile(res: { file: File; }): boolean {
    return this.uploadFile(res.file, this.orderData.designFiles);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadFileImageFile(res: { file: File; }): boolean {
    return this.uploadFile(res.file, this.orderData.imageFiles);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  uploadFileScanFile(res: { file: File; name: string }): boolean {
    const file = new File([res.file], res.name, {
      type: 'application/' + res.name.split('.').pop(),
    });
    return this.uploadFile(file, this.orderData.scanFiles);
  }

  handleRemove(file: UploadFile, list: UploadData[]): void {
    ElMessageBox.confirm((this as any).$t('views.customize.workflow.deleteMessage'), 'info', {
      confirmButtonText: (this as any).$t('views.customize.workflow.yes'),
      cancelButtonText: (this as any).$t('views.customize.workflow.no'),
      type: 'warning',
    })
      .then((confirm) => {
        if (confirm) {
          const index = list.findIndex((store) => store.uid === file.uid);
          if (index >= 0) {
            list.splice(index, 1);
          }
        }
      })
      .catch(() => {
        //
      });
  }

  @Watch('orderData.heightWithoutDeduction', { immediate: true })
  heightWithoutDeductionChanged(): void {
    this.orderData.heightWithDeduction = this.orderData.heightWithoutDeduction + this.orderData.heightDeduction;
  }

  @Watch('orderData.calfCircumferenceWithoutDeduction', { immediate: true })
  calfCircumferenceWithoutDeductionChanged(): void {
    this.orderData.calfCircumferenceWithDeduction = this.orderData.calfCircumferenceWithoutDeduction + this.orderData.calfCircumferenceDeduction;
  }

  get meshColorList(): RGB[] {
    return this.selectedProductInput.treeData.filter((d) => d.colors && d.colors.value).map((data) => (data.colors as AttributeColor).value);
  }

  async colorizeComponentID(componentId: number | null, colorId: string, embossingName: string | undefined, embossingColorId: string | undefined) {
    const item = this.selectedProductInput.treeData.find((d) => d.componentId === componentId);
    if (!item) {
      console.warn(`Component with ID ${componentId} not found.`);
      return;
    }

    await this.applyEmbossing(item, embossingName, embossingColorId);
    await this.applyColor(item, colorId);
  }

  private normalizeName(s?: string) {
    return (s ?? '').trim().toLowerCase();
  }

  async applyEmbossing(
    item: MeshTreeDataItem | null | undefined,
    embossingName?: string,
    embossingColorName?: string
  ) {
    if (!embossingName) return;

    const engr = this.getMeshEngravings2(item)
      .find(d => this.normalizeName(d.thumbnail?.name) === this.normalizeName(embossingName));

    if (!engr) {
      console.warn(`No engraving "${embossingName}" for component ${item?.componentId}`);
      return;
    }

    const file = await TemplateService.getEngravingFile(engr.fileTextureId);
    this.handleSelectEmbossing(file, item);

    if (!embossingColorName) return;

    const palette = this.getMeshEngravingColors(item);
    const colorKey = this.normalizeName(embossingColorName);

    const match =
      palette.find(c => this.normalizeName(c.name) === colorKey) ??
      palette.find(c => this.normalizeName((this as any).$t(`views.colors.${c.name}`)) === colorKey);

    if (match) this.colorizeSelectedEmbossing(match, item);
    else console.warn(`Embossing color "${embossingColorName}" not found for component ${item?.componentId}`);
  }

  async applyColor(item: MeshTreeDataItem | null | undefined, colorName?: string) {

    if (!colorName || this.wtransferId) return;

    const colors = this.getAllColors(item);
    const key = this.normalizeName(colorName);

    // try raw name, then i18n label
    const selected =
      colors.find(c => this.normalizeName(c.name) === key) ??
      colors.find(c => this.normalizeName((this as any).$t(`views.colors.${c.name}`)) === key);

    if (!selected) {
      console.warn(`Color "${colorName}" not found for component ${item?.componentId}`);
      return;
    }
    this.colorizeSelectedMesh(selected, item);
  }

  get meshEmbossingList(): UtilityFile[] {
    return this.selectedProductInput.treeData
      .filter((d) => d.engraving && d.engraving.engravingFile)
      .map((data) => (data.engraving as Engraving).engravingFile as UtilityFile);
  }

  get meshEmbossingColorList(): RGB[] {
    return this.selectedProductInput.treeData
      .filter((d) => d.engraving && d.engraving.engravingColor && d.engraving.engravingColor !== this.transparentColorRgb)
      .map((data) => (data.engraving as Engraving).engravingColor as RGB);
  }

  get meshWtransferList(): UtilityFile[] {
    return this.selectedProductInput.treeData.filter((d) => d.texture && d.texture.textureFile).map((data) => (data.texture as Print).textureFile);
  }

  get meshWtransferColorList(): RGB[] {
    return this.selectedProductInput.treeData
      .filter((d) => d.texture && d.texture.textureColor && d.texture.textureColor !== this.transparentColorRgb)
      .map((data) => (data.texture as Print).textureColor as RGB);
  }

  toNextStep(): void {
    this.workflowModel.changeActiveStep(1);
  }

  findProductZip(): MeshTreeDataItem | undefined {
    return this.selectedProductInput.treeData.find((x) => x.name?.toLowerCase().includes('reißverschluss'));
  }

  zipChanged(zip: string): void {
    const zipMesh = this.findProductZip();
    const meshEditor: any = this.$refs.meshEditor;

    if (zipMesh) {
      if (zip == ZipType.no) {
        this.orderData.sewInByCustomer = false;
        meshEditor.setOpacity(zipMesh, 0);
        this.workflowModel.setStepPrice(zipMesh.id!, Object.keys(CustomizeProgress).indexOf(CustomizeProgress.form), 0);
      } else if (this.orderData.sewInByCustomer) {
        meshEditor.setOpacity(zipMesh, 100);
        this.workflowModel.setStepPrice(zipMesh.id!, Object.keys(CustomizeProgress).indexOf(CustomizeProgress.form), 0);
      } else {
        meshEditor.setOpacity(zipMesh, 100);
        this.workflowModel.setStepPrice(zipMesh.id!, Object.keys(CustomizeProgress).indexOf(CustomizeProgress.form), 0);
      }
    }
  }

  updateProductListState({ productId, name }: { productId: number; name: string }) {
    this.productList = cloneDeep(this.productList).map((p) => {
      if (p.product.productId === productId) p.product.name = name;
      return p;
    });
  }

  confirmOrder(): void {
    this.takeScreenshotOfAllViews();
    this.sendRequest();
  }

  goHome(): void {
    window.location.reload();
    this.workflowModel.setStep(0);
  }

  addToCart(): void {
    //TODO
  }

  async uploadFileToRnd(files: File[], orderId: string) {
    try {
      if (files.length > 0) {
        const res = await rndService.uploadFileRnd({
          orderId,
          files,
        });
        return res?.files?.map((file: { url: any; }) => file?.url) || [];
      }
      return [];
    } catch (error) {
      console.error('Error uploading file to RnD Server:', error);
      return [];
    }
  }

  async sendRequest(): Promise<void> {
    const orderStep = 4;
    if (this.workflowModel.active < orderStep) return;
    const domain = this.userStore.domain;
    const requestData: OrderService.OrderRequestData = this.requestData;
    const clonedRequestData = cloneDeep(requestData);
    this.sendingOrder = true;

    try {
      const scanUrls = requestData.scanFiles;
      const imageUrls = requestData.imageFiles;
      let draftOrder;

      if (requestData.prothesisType === 'Covers' || requestData.prothesisType === 'Brace') {
        if(this.selectedModel !== null) {
          await createOrder(this.requestData, this.selectedModel, false);
          draftOrder = JSON.parse(localStorage.getItem("draftOrder") ?? "null");

          if(draftOrder !== null) {
            localStorage.removeItem('draftOrder');
          }

        const emailOrderPromise = sendEmailOrderTemplate({
          userId: this.userStore.user?.pk?.toString() ?? '',
          HTMLorderTemplate: this.orderTemplate.HTMLTemplate,
          requestData,
          domain: domain as Domain,
            generatedOrderId: draftOrder?.orderNumber ?? 0,
          scanUrls,
          imageUrls,
        });
        const emailConfirmationPromise = sendEmailOrderConfirmationTemplate({
          userId: this.userStore.user?.pk?.toString() ?? '',
          HTMLorderConfirmationTemplate: this.orderTemplate.HTMLConfirmationTemplate,
          requestData,
          domain: domain as Domain,
            generatedOrderId: draftOrder?.orderNumber ?? 0,   
        });

        Promise.all([emailOrderPromise, emailConfirmationPromise])
          .then(() => {
            this.workflowModel.setStep(5);
            ElMessage({
              showClose: true,
              message: (this as any).$t('views.customize.workflow.form.successSendEmail'),
              type: 'success',
              duration: 4000,
            });
          })
          .catch((error) => {
            console.error('Error sending email:', error);
            ElMessage({
              showClose: true,
              message: (this as any).$t('views.customize.workflow.form.error'),
              type: 'error',
              duration: 4000,
            });
          })
          .finally(() => {
            this.workflowModel.finished = false;
            this.fullscreenLoading = false;
            this.sendingOrder = false;
          });
      }
      }
      clonedRequestData.orderNr = draftOrder.orderNumber ?? '';
      clonedRequestData.scanFiles = scanUrls;
      clonedRequestData.imageFiles = imageUrls;
      await OrderService.saveOrderDataToMongoDB(clonedRequestData);
      ['mountingType', 'depth', 'depthRight', 'orientationType','paneelType','calfCircumferenceWithoutDeduction','fenceType','bodySide','kneeJoint','heightWithoutDeduction'].forEach(key =>
        localStorage.removeItem(key)
      );
      this.settingStore.clearAll();
    } catch (error) {
      console.error('Error uploading files:', error);
      this.workflowModel.finished = false;
      this.fullscreenLoading = false;
      this.sendingOrder = false;
      ElMessage({
        showClose: true,
        message: (this as any).$t('views.customize.workflow.form.error'),
        type: 'error',
        duration: 4000,
      });
    }
  }

  //#endregion form

  private async saveAll(): Promise<void> {
    await this.save();
  }

  private async saveUpdated(): Promise<void> {
    await this.save(this.lastUpdateDB);
  }

  //TODO: implement correct save method
  private async save(lastUpdateDB = -1): Promise<void> {
    this.fullscreenLoading = true;
    await setTimeout(() => {
      this.lastUpdateDB = Date.now();
      for (const category of this.selectedProductInput.treeData) {
        const categoryType = Object.values(UploadCategory).find((categoryType) => category.name === (this as any).$t(`enum.upload-category.${categoryType}`));
        if (categoryType) {
          //console.debug(lastUpdateDB);
          //this.updateChildren(categoryType, category, lastUpdateDB);
        }
      }
      this.fullscreenLoading = false;
      //(this.$router as any).askForChanges = this.hasChanges;
    }, 100);
  }

  get hasChanges(): boolean {
    return this.lastUpdateDB < this.selectedProductInput.lastUpdateDB;
  }

  get requestData(): OrderService.OrderRequestData {
    return {
      product: this.selectedModel!.product?.name,
      colorList: this.meshColorList.map((c) => (this as any).$t(`views.colors.${c.name}`)),
      embossingList: this.meshEmbossingList.map((e) => e.name),
      embossingColorList: this.meshEmbossingColorList.map((ec) => (this as any).$t(`views.colors.${ec.name}`)),
      wtransferList: this.meshWtransferList.map((w) => w.name),
      varnish: this.orderData.varnish,
      technicianFirstname: this.orderData.technicianFirstname,
      technicianLastname: this.orderData.technicianLastname,
      technician: this.orderData.technician,
      company: this.orderData.company,
      customerNr: this.orderData.customerNr,
      orderNr: this.orderData.orderNr,
      billingNr: this.orderData.billingNr,
      commissionNo: this.orderData.commissionNo,
      vrNumber: this.orderData.vrNumber,
      vgNumber: this.orderData.vgNumber,
      vsgNumber: this.orderData.vsgNumber,
      mail: this.orderData.mail,
      orderMail: this.userStore.user?.email ?? '',
      coverModel: this.selectedModel!.product?.name,
      prothesisType: this.selectedModel!.product.type.name,
      bodySide: this.orderData.bodySide,
      kneeJoint: this.orderData.kneeJoint,
      foot: this.orderData.foot,
      zip: (this as any).$t(`enum.zipType.${this.orderData.zip}`),
      sewInByCustomer: this.orderData.sewInByCustomer,
      cosmeticEndingAtFoot: this.orderData.cosmeticEndingAtFoot,
      heightWithoutDeduction: +this.orderData.heightWithoutDeduction,
      heightDeduction: +this.orderData.heightDeduction,
      heightWithDeduction: +this.orderData.heightWithDeduction,
      depth: +this.orderData.depth,
      calfCircumferenceWithoutDeduction: +this.orderData.calfCircumferenceWithoutDeduction,
      calfCircumferenceDeduction: +this.orderData.calfCircumferenceDeduction,
      calfCircumferenceWithDeduction: +this.orderData.calfCircumferenceWithDeduction,
      ankleCircumference: +this.orderData.ankleCircumference,
      imageFiles: this.orderData.imageFiles,
      scanFiles: this.orderData.scanFiles,
      designFiles: this.screenshotSrc,
      remarks: this.orderData.remarks,
      balconyType: (this as any).$t(`enum.balconyType.${this.orderData.balconyType}`),
      mountingType: (this as any).$t(`enum.mountingType.${this.orderData.mountingType}`),
      paneelType: (this as any).$t(`enum.paneelType.${this.orderData.paneelType}`),
      orientationType: (this as any).$t(`enum.orientationType.${this.orderData.orientationType}`),
      privacy: this.orderData.privacy,
      isPrivacyAccepted: this.orderData.isPrivacy,
      price: +this.workflowModel.totalPrice,
      bilateralAmputee: this.orderData.bilateralAmputee,
      fenceType: this.orderData.fenceType,
    };
  }

  /*@Watch('selectedProductInput.lastUpdateDB', { immediate: false })
   async onMeshTreeDataDBChanged(): Promise<void> {
     (this.$router as any).askForChanges = this.hasChanges;
   }*/
  //#endregion save

  takeScreenshotOfAllViews(): void {
    const meshEditor: any = this.$refs.meshEditor;
    if (meshEditor) {
      this.screenshotSrc = [];

      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.custom);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.front);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.back);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.top);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.bottom);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.left);
      this.takeScreenshotOfView(meshEditor, THREEEnum.Views.right);
    }
  }

  takeScreenshotOfView(meshEditor: InstanceType<typeof MeshEditor>, view: THREEEnum.Views): void {
    const rendererExport = new THREE.WebGLRenderer({
      antialias: true,
      preserveDrawingBuffer: true,
      alpha: true,
    });
    rendererExport.setClearColor(0xffffff, 0);
    rendererExport.setSize(window.innerWidth, window.innerHeight);

    const camera = this.newCameraFromView(meshEditor, view);

    const img = new Image();
    if (meshEditor.troisRenderer?.scene && camera) {
      rendererExport.render(meshEditor.troisRenderer.scene, camera);
      const dataURL = rendererExport.domElement.toDataURL('image/png');

      img.src = dataURL;
      this.screenshotSrc?.push(img.src);
    }

    rendererExport.dispose();
  }

  takeScreenshotOfCustomView(meshEditor: MeshEditor, view: THREEEnum.Views): void {
    const rendererExport = new THREE.WebGLRenderer({
      antialias: true,
      preserveDrawingBuffer: true,
      alpha: true,
    });
    rendererExport.setClearColor(0xffffff, 0);
    rendererExport.setSize(window.innerWidth, window.innerHeight);
    rendererExport.outputColorSpace = THREE.LinearSRGBColorSpace; // for THREE r150+
    rendererExport.toneMapping = THREE.NoToneMapping; // Disable tone mapping for screenshot

    const camera = this.newCameraFromView(meshEditor, view);
    const scene = meshEditor.troisRenderer?.scene;

    if (!scene || !camera) return;

    // Save existing lights
    const originalLights: THREE.Light[] = [];
    scene.traverse((obj) => {
      if (obj instanceof THREE.Light) {
        originalLights.push(obj as THREE.Light);
      }
    });

    // Remove all existing lights
    originalLights.forEach((light) => scene.remove(light));

    // Add custom lights
    const lightAmbient = new THREE.AmbientLight(0xffffff, 2);
    const lightDir = new THREE.DirectionalLight(0xffffff, 1.2);
    lightDir.position.set(-5, 4, 8);
    lightDir.target.position.set(0, 0, 0); // target the object center
    scene.add(lightDir);
    scene.add(lightDir.target); // Must add target to the scene
    scene.add(lightAmbient);

    // Render the scene with custom lighting
    rendererExport.render(scene, camera);
    const dataURL = rendererExport.domElement.toDataURL('image/png');
    this.screenshotSrc?.push(dataURL);

    // Remove custom lights
    scene.remove(lightAmbient, lightDir, lightDir.target);

    // Restore original lights
    originalLights.forEach((light) => scene.add(light));

    rendererExport.dispose();
  }

  newCameraFromView(meshEditor: InstanceType<typeof MeshEditor>, view: THREEEnum.Views): THREE.PerspectiveCamera {
    if (!meshEditor.troisRenderer?.camera) {
      return new THREE.PerspectiveCamera();
    }
    const editorCamera = meshEditor.troisRenderer.camera as THREE.PerspectiveCamera;

    const camera = new THREE.PerspectiveCamera(editorCamera.fov, window.innerWidth / window.innerHeight, editorCamera.near, editorCamera.far);
    camera.position.x = editorCamera.position.x;
    camera.position.y = editorCamera.position.y;
    camera.position.z = editorCamera.position.z;

    const direction = this.selectView(view);
    THREECamera.fitControlCameraToSelection(camera, meshEditor.troisRenderer.three.cameraCtrl!, meshEditor.troisRenderer.three.scene!.children);

    const distance = camera.position.distanceTo(meshEditor.troisRenderer.three.cameraCtrl!.target);
    camera!.position.copy(direction.multiplyScalar(distance).add(meshEditor.troisRenderer.three.cameraCtrl!.target));
    camera!.lookAt(meshEditor.troisRenderer.three.cameraCtrl!.target);

    return camera;
  }

  selectView(view: THREEEnum.Views): THREE.Vector3 {
    const direction = new THREE.Vector3();
    switch (view) {
      case THREEEnum.Views.front:
        direction.set(0, 0, 1);
        break;
      case THREEEnum.Views.back:
        direction.set(0, 0, -1);
        break;
      case THREEEnum.Views.top:
        direction.set(0, 1, 0);
        break;
      case THREEEnum.Views.bottom:
        direction.set(0, -1, 0);
        break;
      case THREEEnum.Views.right:
        direction.set(1, 0, 0);
        break;
      case THREEEnum.Views.left:
        direction.set(-1, 0, 0);
        break;
      case THREEEnum.Views.custom:
        direction.set(-1, 0.5, 1);
        break;
    }
    return direction;
  }

  confirmOfferPdf(): void {
    this.takeScreenshotOfView(this.$refs.meshEditor as InstanceType<typeof MeshEditor>, THREEEnum.Views.custom);
    //await new Promise(res => setTimeout(res, 5000));
    this.createOfferPdf();
  }

  async createOfferPdf(): Promise<void> {
    this.loadingOfferPdf = true;
    this.requestData.scanFiles = [];
    this.requestData.imageFiles = [];
    const domainId = this.userStore.domain?.domainId;
    const downloadPdfBase64 = await OrderService.createPdfOffer(this.requestData, this.selectedModelId!, domainId ?? 2);

    const pdfPartListHTMLElement = document.getElementById('pdf-offer') as HTMLAnchorElement;

    if (pdfPartListHTMLElement) {
      pdfPartListHTMLElement.href = downloadPdfBase64.toString();
      pdfPartListHTMLElement.click();
    }
    this.loadingOfferPdf = false;
  }

  @Watch('window.innerWidth', { immediate: true })
  isSmallWindow(): boolean {
    if (window.innerWidth < 800) {
      // Small Device
      return true;
    } else {
      // Large Device
      return false;
    }
  }

  async defaultUndo(): Promise<void> {
    //
  }

  async defaultRedo(): Promise<void> {
    //
  }

  convertToUrl(model: Model2): string | null {
    if (model.product && model.product.thumbnail) {
      return model.product.thumbnail.content;
    }
    return null;
  }

  productQualityChanged(selectedProductQuality: string): void {
    this.selectedProductQuality = selectedProductQuality;
    this.loadTemplateFromDB();
  }

  async loadScan(): Promise<void> {
    //no automatic adaption to scan file
    if (!this.selectedScan || !this.selectedScan.fileId) return;

    this.loadedScan = await customerService.getScanById(this.selectedScan.fileId);
  }

  updateModelSize() {
    this.abortController.abort();
    this.meshEditorLoading = true;
    this.selectedProductInput.clear();
    this.abortController = new AbortController();

    if (this.filteredFenceModels) {
      if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredFenceModels[0];
      } else if (this.orderData.mountingType == MountingType.bottom && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredFenceModels[1];
      } else if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.portrait) {
        this.selectedModel = this.filteredFenceModels[2];
      }

      if (this.selectedModel) {
        this.selectedModelId = this.selectedModel.modelId;

        modelService
          .createNewFenceModel(
            this.selectedModelId,
            this.orderData.calfCircumferenceWithoutDeduction,
            this.orderData.heightWithoutDeduction,
            this.orderData.depth,
            this.orderData.fenceType,
            this.userStore.user?.pk ?? 0,
            this.abortController
          )
          .then((model) => {
            if (!this.selectedModelId) {
              throw new Error('selectedModelId is Empty');
            }

            modelService.deleteModel(this.selectedModelId);

            this.selectedModelId = model.modelId;
            this.loadTemplate(model);
          });
      }
    } else if (this.filteredBalconyModels) {
      if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredBalconyModels[0];
      } else if (this.orderData.mountingType == MountingType.bottom && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredBalconyModels[1];
      } else if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.portrait) {
        this.selectedModel = this.filteredBalconyModels[2];
      }

      if (this.selectedModel) {
        this.selectedModelId = this.selectedModel.modelId;

        modelService
          .createNewBalconyModel(
            this.selectedModelId,
            this.orderData.calfCircumferenceWithoutDeduction,
            this.orderData.heightWithoutDeduction,
            this.orderData.depth,
            this.orderData.depthRight,
            this.orderData.balconyType,
            // 17 //christian bayer,
            this.userStore.user?.pk ?? 0,
            this.abortController
          )
          .then((model) => {
            if (!this.selectedModelId) {
              throw new Error('selectedModelId is Empty');
            }

            modelService.deleteModel(this.selectedModelId);

            this.selectedModelId = model.modelId;
            this.loadTemplate(model);
          });
      }
    } else if (this.filteredFenceSunModels) {
      if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredFenceSunModels[0];
      } else if (this.orderData.mountingType == MountingType.bottom && this.orderData.paneelType == PaneelType.landscape) {
        this.selectedModel = this.filteredFenceSunModels[0];
      } else if (this.orderData.mountingType == MountingType.front && this.orderData.paneelType == PaneelType.portrait) {
        this.selectedModel = this.filteredFenceSunModels[0];
      }

      if (this.selectedModel) {
        this.selectedModelId = this.selectedModel.modelId;

        modelService
          .createNewFenceSunModel(
            this.selectedModelId,
            this.orderData.calfCircumferenceWithoutDeduction,
            this.orderData.heightWithoutDeduction,
            this.orderData.depth,
            this.orderData.depthRight,
            this.orderData.fenceType,
            this.orderData.paneelType,
            this.userStore.user?.pk ?? 0,
            this.abortController
          )
          .then((model) => {
            if (!this.selectedModelId) {
              throw new Error('selectedModelId is Empty');
            }

            modelService.deleteModel(this.selectedModelId);
            this.selectedModelId = model.modelId;
            this.loadTemplate(model);
          });
      }
    }
  }

  generateBalconyModel(): void {
    this.selectedProductInput.clear();
    this.meshEditorLoading = true;
    this.abortController = new AbortController();
    const domain = this.authentication.primaryDomain;
    modelService
      .getModelsByUrlSuffix(this.supplierUrl ?? domain?.urlSuffix ?? '', this.productTypeId)
      .then((models) => {
        const mList = models.filter((item) => !item.basedOn);
        if (mList.length > 0) {
          // Use the first model from the list.
          this.selectedModel = mList[0];
          this.selectedModelId = mList[0].modelId;

          modelService
            .createNewBalconyModel(
              this.selectedModelId,
              this.orderData.calfCircumferenceWithoutDeduction,
              this.orderData.heightWithoutDeduction,
              this.orderData.depth,
              this.orderData.depthRight,
              this.orderData.balconyType,
              1,
              this.abortController
            )
            .then((model) => {
              if (model) {
                this.selectedModelId = model.modelId;
              }
              this.loadTemplate(model);
              this.meshEditorLoading = false;
            })
            .catch((err) => {
              console.error(err);
              this.meshEditorLoading = false;
            });
        } else {
          console.error('No valid models returned from getModelsByUrlSuffix');
          this.meshEditorLoading = false;
        }
      })
      .catch((err) => {
        console.error(err);
        this.meshEditorLoading = false;
      });
  }

  generateFenceSunModel(): void {
    this.selectedProductInput.clear();
    this.meshEditorLoading = true;
    this.abortController = new AbortController();
    const domain = this.authentication.primaryDomain;
    modelService.getModelsByUrlSuffix(this.supplierUrl ?? domain?.urlSuffix ?? '', this.productTypeId).then((models) => {
      const mList = models.filter((item) => !item.basedOn);
      if (mList.length > 0) {
        this.selectedModel = mList[0];
        this.selectedModelId = mList[0].modelId;

        modelService
          .createNewFenceSunModel(
            this.selectedModelId,
            this.orderData.calfCircumferenceWithoutDeduction,
            this.orderData.heightWithoutDeduction,
            this.orderData.depth,
            this.orderData.depthRight,
            this.orderData.fenceType,
            this.orderData.paneelType,
            1,
            this.abortController
          )
          .then((model) => {
            if (model) {
              this.selectedModelId = model.modelId;
            }
            this.loadTemplate(model);
          });
      }
    });
  }

  generateFenceModel(): void {
    this.selectedProductInput.clear();
    this.meshEditorLoading = true;
    this.abortController = new AbortController();

    if (this.selectedModelId && this.selectedModel?.product?.productId) {
      modelService.getModelsByProductId(this.selectedModel.product.productId).then((models) => {
        this.filteredFenceModels = models.filter((item) => !item.basedOn);
        this.selectedModel = this.filteredFenceModels[0];

        if (this.selectedModel) {
          this.selectedModelId = this.selectedModel.modelId;

          modelService
            .createNewFenceModel(
              this.selectedModelId,
              this.orderData.calfCircumferenceWithoutDeduction,
              this.orderData.heightWithoutDeduction,
              this.orderData.depth,
              this.orderData.fenceType,
              this.userStore.user?.pk ?? 0,
              this.abortController
            )
            .then((model) => {
              this.selectedModelId = model.modelId;
              this.loadTemplate(model);
            });
        }
      });
    }
  }

  generateSuspendedLightModel(): void {
    this.selectedProductInput.clear();
    this.meshEditorLoading = true;
    this.abortController = new AbortController();

    if (this.selectedModelId && this.selectedModel?.product?.productId) {
      modelService.getModelsByProductId(this.selectedModel.product.productId).then((models) => {
        this.filteredLighModels = models.filter((item) => !item.basedOn);
        this.selectedModel = this.filteredLighModels[0];

        if (this.selectedModel) {
          this.selectedModelId = this.selectedModel.modelId;

          modelService
            .createNewSuspendedLightModel(
              this.selectedModelId,
              this.orderData.color,
              this.orderData.mountingProfileType,
              this.orderData.lightCoverType,
              this.orderData.vFour,
              this.orderData.iPRatingType,
              this.orderData.lightColorType,
              this.orderData.lightLength,
              this.abortController
            )
            .then((model) => {
              this.selectedModelId = model.modelId;
              this.loadTemplate(model);
            });
        }
      });
    }
  }

  generateBathtubModel(): void {
    this.meshEditorLoading = true;
    this.abortController = new AbortController();
    this.selectedProductInput.clear();

    if (this.selectedModel) {
      this.selectedModelId = this.selectedModel.modelId;

      modelService
        .createNewBathtubModel(
          this.selectedModelId,
          this.orderData.bathtubType,
          this.orderData.wallpanels,
          this.orderData.panelVariant,
          this.orderData.singleType,
          this.orderData.comboType,
          this.userStore.user?.pk ?? 0,
          this.abortController
        )
        .then((model) => {
          this.selectedModelId = model.modelId;
          this.loadTemplate(model);
        });
    }
  }

  async meshesLoaded() {
    this.isApplyingColors = true;
    if (this.selectedProductInput.treeData?.length > 0) {
      this.setPartSelection();
      await this.setTotalPrice();

      if (this.attrLoadPromise) {
        await this.attrLoadPromise;
      }

      await this.$nextTick();

      await this.processComponentTree();
    }
    this.orderData.coverModel = this.selectedName;
    this.meshEditorLoading = false;
    this.isApplyingColors = false;
  }


  /*async setAttributes() {
    let i = 0;
    this.selectedProductInput.treeData.forEach(async (treeData) => {
      if (this.embossingId) {
        await waitFor(() => this.embossingListLoading.get(treeData.uuid) == true);
        if (this.embossingId) {
          let selectedEngravingFile;
          if (Array.isArray(this.embossingId)) {
            selectedEngravingFile = await TemplateService.getEngravingFile(this.getMeshEngravings2(treeData)[this.embossingId[i]].fileTextureId);
          } else {
            selectedEngravingFile = await TemplateService.getEngravingFile(this.getMeshEngravings2(treeData)[this.embossingId].fileTextureId);
          }
          this.handleSelectEmbossing(selectedEngravingFile, treeData);
          if (this.embossingColorId) {
            this.colorizeSelectedEmbossing(
              Array.isArray(this.embossingColorId)
                ? this.getMeshEngravingColors(treeData)[this.embossingColorId[i]]
                : this.getMeshEngravingColors(treeData)[this.embossingColorId],
              treeData
            );
          }
        }
      } else if (this.wtransferId) {
        await waitFor(() => this.wtransferListLoading.get(treeData.uuid) == true);
        if (this.wtransferId) {
          let selectedTextureFile;
          if (Array.isArray(this.wtransferId)) {
            selectedTextureFile = await TemplateService.getEngravingFile(this.getMeshTextures2(treeData)[this.wtransferId[i]].fileTextureId);
          } else {
            selectedTextureFile = await TemplateService.getEngravingFile(this.getMeshTextures2(treeData)[this.wtransferId].fileTextureId);
          }
          this.handleSelectWtransfer(selectedTextureFile, treeData);
        }
      }

      if (this.colorId && !this.wtransferId) {
        await waitFor(() => this.colorListLoading.get(treeData.uuid) == true);
        if (this.colorId) {
          const colorList = this.getAllColors(treeData);
          this.colorizeSelectedMesh(Array.isArray(this.colorId) ? colorList[this.colorId[i]] : colorList[this.colorId], treeData);
        }
      }

      i++;
    });
  }*/

  productQualityToInt(productQuality: string): number {
    switch (productQuality) {
      case ProductQuality.original:
        return 1;
      case ProductQuality.high:
        return 4;
      case ProductQuality.middle:
        return 8;
      case ProductQuality.low:
        return 16;
    }
    return 1;
  }

  setPartSelection() {
    this.selectedProductInput.selectItem(this.selectedProductInput.treeData[0], true, true);
  }

  async setTotalPrice() {
    this.setBaseProductPrice();
    await this.setComponentPrices();
    this.zipChanged(this.orderData.zip);
  }

  private setBaseProductPrice() {
    this.workflowModel.initTotalPrice(this.selectedProductInput);

    const countryCode = this.IPInfo?.countryCode;
    const basePrices = this.selectedModel?.product?.basePrices ?? [];
    const defaultPrice = basePrices.find(p => p.country === defaultPriceCountryCode)?.price;
    const basePrice = basePrices.find(p => p.country === countryCode)?.price ?? defaultPrice;

    this.workflowModel.setStepPrice(
      'product',
      Object.keys(CustomizeProgress).indexOf(CustomizeProgress.product),
      basePrice!
    );
  }

  private async setComponentPrices() {
    const components = this.selectedModel?.components;
    if (!components) return;

    for (const component of components) {
      const price = await this.calculateComponentPrice(component);
      const treeData = this.selectedProductInput.treeData.find(t => t.componentId == component.componentId);
      if (treeData) treeData.basePrice = price;

      this.workflowModel.setStepPrice(
        component.uuid,
        Object.keys(CustomizeProgress).indexOf(CustomizeProgress.product),
        price
      );
    }
  }

  private async calculateComponentPrice(component: Component1) {
    const treeData = this.selectedProductInput.treeData.find(t => t.componentId == component.componentId);
    if (!treeData) return 0.0;

    switch (component.unit) {
      case unit_type.Pcs:
        return component.basePrice;

      case unit_type.M:
        await this.ensureSizeLoaded(treeData);
        return treeData.size ? (treeData.size.width / 1000) * component.basePrice : 0.0;

      case unit_type.Qm:
        await this.ensureSizeLoaded(treeData);
        return treeData.size
          ? (treeData.size.width / 1000) * (treeData.size.height / 1000) * component.basePrice
          : 0.0;

      default:
        return 0.0;
    }
  }

  private async ensureSizeLoaded(treeData: MeshTreeDataItem) {
    await waitFor(() => this.sizeListLoading.get(treeData.uuid) === true);
  }


  startAr(){
    const xrButton = document.getElementById('xr-button')
    if(!xrButton) return
    xrButton.click()
    this.enterAR = !this.enterAR
  }
}
</script>

<style lang="scss">
/* Global layout */
html, body, #app, .el-container {
  overflow: hidden !important;
}

.order-number-text { font-size: 1.25rem; }

#btn-ar {
  position: absolute;
  top: 50%;
  right: 10px;
  z-index: 99999;
  transform: rotate(90deg);
}

/* Completed order screen */
#completed-order {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  height: 93vh;
  padding-bottom: 1rem;

  .container { margin-top: 15%; text-align: center; }

  .title {
    margin-top: 3rem;
    margin-bottom: 8rem;
    font-size: 32px;
    font-weight: bold;
  }

  .section-group.end {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 2rem;

    button {
      background-color: var(--color-primary);
      color: var(--primary-text);
      border-radius: 5px !important;
      padding: 10px 50px !important;
    }
  }
}

/* Desktop shell height */
.page-shell { height: 93vh; }

/* ---------- Mobile (≤ 828px) ---------- */
@media (max-width: 828px) {
  /* Split mode (steps <= 3): 50/50 layout */
  .config-split.page-shell { height: 100vh; }

  .config-split .main-content {
    display: flex;
    flex-direction: column;
    height: 50vh !important;
    min-height: 50vh !important;
    max-height: 50vh !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
  }

  .config-split .main-content :deep(.trois-renderer),
  .config-split .main-content :deep(canvas) {
    width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    display: block;
  }

  .config-split .sidemenu.is-phone.expanded { height: 50vh !important; }
  .config-split .sidemenu.is-phone .sidemenu-body {
    max-height: calc(50vh - 3.5rem - 56px) !important;
  }

  /* Non-split (steps >= 4): viewer fills page shell */
  .page-shell:not(.config-split) .main-content {
    height: 93vh !important;
    min-height: 93vh !important;
    max-height: 93vh !important;
    overflow: hidden !important;
  }

  .page-shell:not(.config-split) .main-content :deep(.trois-renderer),
  .page-shell:not(.config-split) .main-content :deep(canvas) {
    width: 100% !important;
    height: 100% !important;
    max-height: 100% !important;
    display: block;
  }
}
</style>

